import Sa, { jsxs as S, jsx as l, Fragment as ee } from "react/jsx-runtime";
import * as ne from "react";
import { forwardRef as et, useState as E, useCallback as Ie, useEffect as Q, createContext as Ne, useContext as Oe, useLayoutEffect as Na, useRef as xe, useMemo as wn } from "react";
import { a as kt, c as X, i as Dt, e as Oa, b as _a } from "./common.utils-016769eb.js";
import { h as Mt, T as ae } from "./JumboTabs-93fb3011.js";
import { I as J, C as Cn, c as kn, A as Pa, T as Fa } from "./SearchInput-47ac50eb.js";
import { g as tt, s as we, B as Ia, d as Ra, a3 as Dn, c as nt, a6 as St, a as at, z as ze, r as Mn, u as Nt, a2 as Ta, T as Wa, ao as Ea, t as Te, ag as Sn, a9 as Ba, A as La, P as Ya, v as $a } from "./Search-4d6031ad.js";
import { M as za, G as Xe } from "./Grid-242d36e3.js";
import { D as Aa } from "./Tooltip-34b208dc.js";
import { g as rt, _ as Y, b as ot, P as g, d as de, a as Nn } from "./createTheme-6e68f5ca.js";
import { r as Ha, i as Va } from "./utils.entry-04e4214a.js";
function ja(e) {
  return rt("PrivateSwitchBase", e);
}
tt("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const qa = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"], Ua = (e) => {
  const {
    classes: t,
    checked: n,
    disabled: a,
    edge: r
  } = e, o = {
    root: ["root", n && "checked", a && "disabled", r && `edge${de(r)}`],
    input: ["input"]
  };
  return at(o, ja, t);
}, Ga = we(Ia)(({
  ownerState: e
}) => Y({
  padding: 9,
  borderRadius: "50%"
}, e.edge === "start" && {
  marginLeft: e.size === "small" ? -3 : -12
}, e.edge === "end" && {
  marginRight: e.size === "small" ? -3 : -12
})), Xa = we("input")({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), On = /* @__PURE__ */ ne.forwardRef(function(t, n) {
  const {
    autoFocus: a,
    checked: r,
    checkedIcon: o,
    className: i,
    defaultChecked: s,
    disabled: d,
    disableFocusRipple: c = !1,
    edge: u = !1,
    icon: f,
    id: h,
    inputProps: m,
    inputRef: p,
    name: b,
    onBlur: v,
    onChange: x,
    onFocus: y,
    readOnly: C,
    required: N = !1,
    tabIndex: M,
    type: I,
    value: T
  } = t, R = ot(t, qa), [A, B] = Ra({
    controlled: r,
    default: !!s,
    name: "SwitchBase",
    state: "checked"
  }), L = Dn(), H = ($) => {
    y && y($), L && L.onFocus && L.onFocus($);
  }, fe = ($) => {
    v && v($), L && L.onBlur && L.onBlur($);
  }, he = ($) => {
    if ($.nativeEvent.defaultPrevented)
      return;
    const ie = $.target.checked;
    B(ie), x && x($, ie);
  };
  let q = d;
  L && typeof q > "u" && (q = L.disabled);
  const me = I === "checkbox" || I === "radio", k = Y({}, t, {
    checked: A,
    disabled: q,
    disableFocusRipple: c,
    edge: u
  }), w = Ua(k);
  return /* @__PURE__ */ S(Ga, Y({
    component: "span",
    className: nt(w.root, i),
    centerRipple: !0,
    focusRipple: !c,
    disabled: q,
    tabIndex: null,
    role: void 0,
    onFocus: H,
    onBlur: fe,
    ownerState: k,
    ref: n
  }, R, {
    children: [/* @__PURE__ */ l(Xa, Y({
      autoFocus: a,
      checked: r,
      defaultChecked: s,
      className: w.input,
      disabled: q,
      id: me ? h : void 0,
      name: b,
      onChange: he,
      readOnly: C,
      ref: p,
      required: N,
      ownerState: k,
      tabIndex: M,
      type: I
    }, I === "checkbox" && T === void 0 ? {} : {
      value: T
    }, m)), A ? o : f]
  }));
});
process.env.NODE_ENV !== "production" && (On.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: g.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: g.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: g.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: g.object,
  /**
   * @ignore
   */
  className: g.string,
  /**
   * @ignore
   */
  defaultChecked: g.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: g.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: g.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: g.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: g.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: g.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: g.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: St,
  /*
   * @ignore
   */
  name: g.string,
  /**
   * @ignore
   */
  onBlur: g.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: g.func,
  /**
   * @ignore
   */
  onFocus: g.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: g.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: g.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: g.object,
  /**
   * @ignore
   */
  tabIndex: g.oneOfType([g.number, g.string]),
  /**
   * The input component prop `type`.
   */
  type: g.string.isRequired,
  /**
   * The value of the component.
   */
  value: g.any
});
const _n = On, Qa = ze(/* @__PURE__ */ l("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), Ja = ze(/* @__PURE__ */ l("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), Ka = ze(/* @__PURE__ */ l("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function Za(e) {
  return rt("MuiCheckbox", e);
}
const er = tt("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), ut = er, tr = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size", "className"], nr = (e) => {
  const {
    classes: t,
    indeterminate: n,
    color: a,
    size: r
  } = e, o = {
    root: ["root", n && "indeterminate", `color${de(a)}`, `size${de(r)}`]
  }, i = at(o, Za, t);
  return Y({}, t, i);
}, ar = we(_n, {
  shouldForwardProp: (e) => Mn(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.indeterminate && t.indeterminate, n.color !== "default" && t[`color${de(n.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => Y({
  color: (e.vars || e).palette.text.secondary
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${t.color === "default" ? e.vars.palette.action.activeChannel : e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Nn(t.color === "default" ? e.palette.action.active : e.palette[t.color].main, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.color !== "default" && {
  [`&.${ut.checked}, &.${ut.indeterminate}`]: {
    color: (e.vars || e).palette[t.color].main
  },
  [`&.${ut.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  }
})), rr = /* @__PURE__ */ l(Ja, {}), or = /* @__PURE__ */ l(Qa, {}), ir = /* @__PURE__ */ l(Ka, {}), Pn = /* @__PURE__ */ ne.forwardRef(function(t, n) {
  var a, r;
  const o = Nt({
    props: t,
    name: "MuiCheckbox"
  }), {
    checkedIcon: i = rr,
    color: s = "primary",
    icon: d = or,
    indeterminate: c = !1,
    indeterminateIcon: u = ir,
    inputProps: f,
    size: h = "medium",
    className: m
  } = o, p = ot(o, tr), b = c ? u : d, v = c ? u : i, x = Y({}, o, {
    color: s,
    indeterminate: c,
    size: h
  }), y = nr(x);
  return /* @__PURE__ */ l(ar, Y({
    type: "checkbox",
    inputProps: Y({
      "data-indeterminate": c
    }, f),
    icon: /* @__PURE__ */ ne.cloneElement(b, {
      fontSize: (a = b.props.fontSize) != null ? a : h
    }),
    checkedIcon: /* @__PURE__ */ ne.cloneElement(v, {
      fontSize: (r = v.props.fontSize) != null ? r : h
    }),
    ownerState: x,
    ref: n,
    className: nt(y.root, m)
  }, p, {
    classes: y
  }));
});
process.env.NODE_ENV !== "production" && (Pn.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the component is checked.
   */
  checked: g.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: g.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: g.object,
  /**
   * @ignore
   */
  className: g.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: g.oneOfType([g.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), g.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: g.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: g.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: g.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: g.node,
  /**
   * The id of the `input` element.
   */
  id: g.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: g.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: g.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: g.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: St,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: g.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: g.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: g.oneOfType([g.oneOf(["medium", "small"]), g.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: g.oneOfType([g.arrayOf(g.oneOfType([g.func, g.object, g.bool])), g.func, g.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: g.any
});
const Ot = Pn;
function sr(e) {
  return rt("MuiInputAdornment", e);
}
const lr = tt("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]), en = lr;
var tn;
const cr = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"], dr = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, t[`position${de(n.position)}`], n.disablePointerEvents === !0 && t.disablePointerEvents, t[n.variant]];
}, ur = (e) => {
  const {
    classes: t,
    disablePointerEvents: n,
    hiddenLabel: a,
    position: r,
    size: o,
    variant: i
  } = e, s = {
    root: ["root", n && "disablePointerEvents", r && `position${de(r)}`, i, a && "hiddenLabel", o && `size${de(o)}`]
  };
  return at(s, sr, t);
}, fr = we("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: dr
})(({
  theme: e,
  ownerState: t
}) => Y({
  display: "flex",
  height: "0.01em",
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active
}, t.variant === "filled" && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${en.positionStart}&:not(.${en.hiddenLabel})`]: {
    marginTop: 16
  }
}, t.position === "start" && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, t.position === "end" && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, t.disablePointerEvents === !0 && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: "none"
})), Fn = /* @__PURE__ */ ne.forwardRef(function(t, n) {
  const a = Nt({
    props: t,
    name: "MuiInputAdornment"
  }), {
    children: r,
    className: o,
    component: i = "div",
    disablePointerEvents: s = !1,
    disableTypography: d = !1,
    position: c,
    variant: u
  } = a, f = ot(a, cr), h = Dn() || {};
  let m = u;
  u && h.variant && process.env.NODE_ENV !== "production" && u === h.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), h && !m && (m = h.variant);
  const p = Y({}, a, {
    hiddenLabel: h.hiddenLabel,
    size: h.size,
    disablePointerEvents: s,
    position: c,
    variant: m
  }), b = ur(p);
  return /* @__PURE__ */ l(Ta.Provider, {
    value: null,
    children: /* @__PURE__ */ l(fr, Y({
      as: i,
      ownerState: p,
      className: nt(b.root, o),
      ref: n
    }, f, {
      children: typeof r == "string" && !d ? /* @__PURE__ */ l(Wa, {
        color: "text.secondary",
        children: r
      }) : /* @__PURE__ */ S(ne.Fragment, {
        children: [c === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          tn || (tn = /* @__PURE__ */ l("span", {
            className: "notranslate",
            children: "​"
          }))
        ) : null, r]
      })
    }))
  });
});
process.env.NODE_ENV !== "production" && (Fn.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: g.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: g.object,
  /**
   * @ignore
   */
  className: g.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: g.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: g.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: g.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: g.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: g.oneOfType([g.arrayOf(g.oneOfType([g.func, g.object, g.bool])), g.func, g.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: g.oneOf(["filled", "outlined", "standard"])
});
const Ge = Fn, hr = ze(/* @__PURE__ */ l("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked"), mr = ze(/* @__PURE__ */ l("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked"), pr = we("span")({
  position: "relative",
  display: "flex"
}), gr = we(hr)({
  // Scale applied to prevent dot misalignment in Safari
  transform: "scale(1)"
}), vr = we(mr)(({
  theme: e,
  ownerState: t
}) => Y({
  left: 0,
  position: "absolute",
  transform: "scale(0)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeIn,
    duration: e.transitions.duration.shortest
  })
}, t.checked && {
  transform: "scale(1)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeOut,
    duration: e.transitions.duration.shortest
  })
}));
function _t(e) {
  const {
    checked: t = !1,
    classes: n = {},
    fontSize: a
  } = e, r = Y({}, e, {
    checked: t
  });
  return /* @__PURE__ */ S(pr, {
    className: n.root,
    ownerState: r,
    children: [/* @__PURE__ */ l(gr, {
      fontSize: a,
      className: n.background,
      ownerState: r
    }), /* @__PURE__ */ l(vr, {
      fontSize: a,
      className: n.dot,
      ownerState: r
    })]
  });
}
process.env.NODE_ENV !== "production" && (_t.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: g.bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: g.object,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: g.oneOf(["small", "medium"])
});
const In = /* @__PURE__ */ ne.createContext(void 0);
process.env.NODE_ENV !== "production" && (In.displayName = "RadioGroupContext");
const br = In;
function yr() {
  return ne.useContext(br);
}
function xr(e) {
  return rt("MuiRadio", e);
}
const wr = tt("MuiRadio", ["root", "checked", "disabled", "colorPrimary", "colorSecondary", "sizeSmall"]), nn = wr, Cr = ["checked", "checkedIcon", "color", "icon", "name", "onChange", "size", "className"], kr = (e) => {
  const {
    classes: t,
    color: n,
    size: a
  } = e, r = {
    root: ["root", `color${de(n)}`, a !== "medium" && `size${de(a)}`]
  };
  return Y({}, t, at(r, xr, t));
}, Dr = we(_n, {
  shouldForwardProp: (e) => Mn(e) || e === "classes",
  name: "MuiRadio",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`color${de(n.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => Y({
  color: (e.vars || e).palette.text.secondary
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${t.color === "default" ? e.vars.palette.action.activeChannel : e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Nn(t.color === "default" ? e.palette.action.active : e.palette[t.color].main, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.color !== "default" && {
  [`&.${nn.checked}`]: {
    color: (e.vars || e).palette[t.color].main
  }
}, {
  [`&.${nn.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  }
}));
function Mr(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
const an = /* @__PURE__ */ l(_t, {
  checked: !0
}), rn = /* @__PURE__ */ l(_t, {}), Rn = /* @__PURE__ */ ne.forwardRef(function(t, n) {
  var a, r;
  const o = Nt({
    props: t,
    name: "MuiRadio"
  }), {
    checked: i,
    checkedIcon: s = an,
    color: d = "primary",
    icon: c = rn,
    name: u,
    onChange: f,
    size: h = "medium",
    className: m
  } = o, p = ot(o, Cr), b = Y({}, o, {
    color: d,
    size: h
  }), v = kr(b), x = yr();
  let y = i;
  const C = Ea(f, x && x.onChange);
  let N = u;
  return x && (typeof y > "u" && (y = Mr(x.value, o.value)), typeof N > "u" && (N = x.name)), /* @__PURE__ */ l(Dr, Y({
    type: "radio",
    icon: /* @__PURE__ */ ne.cloneElement(c, {
      fontSize: (a = rn.props.fontSize) != null ? a : h
    }),
    checkedIcon: /* @__PURE__ */ ne.cloneElement(s, {
      fontSize: (r = an.props.fontSize) != null ? r : h
    }),
    ownerState: b,
    classes: v,
    name: N,
    checked: y,
    onChange: C,
    ref: n,
    className: nt(v.root, m)
  }, p));
});
process.env.NODE_ENV !== "production" && (Rn.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the component is checked.
   */
  checked: g.bool,
  /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */
  checkedIcon: g.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: g.object,
  /**
   * @ignore
   */
  className: g.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: g.oneOfType([g.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), g.string]),
  /**
   * If `true`, the component is disabled.
   */
  disabled: g.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: g.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */
  icon: g.node,
  /**
   * The id of the `input` element.
   */
  id: g.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: g.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: St,
  /**
   * Name attribute of the `input` element.
   */
  name: g.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: g.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: g.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */
  size: g.oneOfType([g.oneOf(["medium", "small"]), g.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: g.oneOfType([g.arrayOf(g.oneOfType([g.func, g.object, g.bool])), g.func, g.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: g.any
});
const Sr = Rn, Nr = Te(() => ({
  rootThin: {
    "&.MuiButton-root": {
      fontSize: "14px",
      lineHeight: "16px",
      textTransform: "capitalize",
      fontWeight: "bold",
      textAlign: "center",
      padding: "14px 28px",
      borderRadius: "4px",
      height: "36px"
    }
  },
  root: (e) => ({
    '&[class*=" MuiButton-root"]': {
      letterSpacing: 0,
      fontSize: e.size === "legacy" ? "12px" : "16px",
      lineHeight: "20px",
      fontWeight: e.size === "legacy" ? 500 : 600,
      textTransform: e.size === "legacy" ? "!capitalize" : "capitalize",
      textAlign: "center",
      padding: e.size === "legacy" ? "6px 16px" : "8px 16px",
      borderRadius: "4px",
      whiteSpace: "normal",
      "& [class*=MuiButton-label]": {
        height: "initial"
      }
    }
  }),
  outlined: {
    height: "36px"
  },
  containedPrimary: {
    whiteSpace: "pre",
    backgroundColor: "#DE521F",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#B63F15"
    },
    "&.Mui-disabled": {
      backgroundColor: "#CBCBCB",
      color: "#757575",
      borderColor: "1px solid #F2F2F2",
      "& hr": {
        opacity: "0.2 !important"
      }
    },
    "&.MuiButton-sizeSmall": {
      fontWeight: "500 !important"
    }
  },
  outlinedPrimary: {
    whiteSpace: "pre",
    backgroundColor: "#FFFFFF",
    border: "1px solid #008CFF",
    color: "#008CFF",
    '&[class*=" MuiButton-outlinedPrimary"]:hover': {
      backgroundColor: "#EAF5FF",
      border: "1px solid #008CFF"
    },
    "&.Mui-disabled": {
      border: "1px solid #008CFF80",
      color: "#008CFF80",
      "& hr": {
        opacity: "0.5 !important"
      }
    },
    "& hr": {
      borderLeft: "1px solid #008CFF !important"
    }
  },
  textPrimary: {
    minWidth: "unset",
    padding: "unset",
    color: "#008CFF",
    "&.MuiButton-textPrimary:hover": {
      backgroundColor: "#EAF5FF",
      color: "#008CFF"
    },
    "&.MuiButton-root:hover": {
      backgroundColor: "#EAF5FF",
      color: "#008CFF"
    },
    "&.Mui-disabled": {
      color: "#008CFF80",
      "& hr": {
        opacity: "0.5 !important"
      }
    },
    "& hr": {
      borderLeft: "1px solid #008CFF !important",
      marginLeft: "5px"
    }
  },
  sizeSmall: {
    height: "24px",
    fontSize: "14px !important",
    padding: "2px 8px !important",
    '&[class*="MuiButton-sizeSmall"]': {
      fontWeight: "500 !important"
    },
    "&[class*=MuiButton-text]": {
      padding: "4px !important"
    }
  },
  sizeLarge: {
    height: "40px !important",
    padding: "10px 16px !important",
    fontSize: "16px !important"
  },
  divider: (e) => ({
    borderLeft: "1px solid #EFF1FF",
    height: e.size === "small" ? "14px" : "20px",
    opacity: "0.5",
    marginLeft: e.size === "small" ? "8px" : "16px"
  })
}));
function Or(e, t) {
  const {
    children: n,
    onClick: a,
    variant: r = "contained",
    color: o = "primary",
    size: i = "medium",
    fullWidth: s = !1,
    disabled: d = !1,
    type: c,
    thin: u = !1,
    IconComp: f,
    className: h = "",
    tabIndex: m,
    IconCompRight: p,
    isIconStyle: b = !1,
    verticalDivider: v = !1,
    id: x,
    toLowerCase: y = !0,
    disableRipple: C = !1,
    ...N
  } = e, {
    containedPrimary: M,
    outlinedPrimary: I,
    textPrimary: T,
    root: R,
    outlined: A,
    rootThin: B,
    sizeSmall: L,
    sizeLarge: H,
    divider: fe
  } = Nr({ size: i }), he = kt(N), q = {
    fontSize: i
  };
  i !== "medium" && (q.fontSize = i);
  const me = f && /* @__PURE__ */ l(f, { ...q }), k = p && /* @__PURE__ */ l(p, { className: b ? "ml-[-6px]" : "" });
  let w = u ? B : R;
  return w += ` ${h}`, /* @__PURE__ */ S(
    za,
    {
      variant: r,
      id: x,
      ref: t,
      classes: {
        root: R,
        outlined: A,
        containedPrimary: M,
        outlinedPrimary: I,
        textPrimary: T,
        sizeSmall: L,
        sizeLarge: H
      },
      color: o,
      size: i,
      disabled: d,
      onClick: a,
      fullWidth: s,
      type: c,
      disableElevation: !0,
      className: w,
      startIcon: me,
      endIcon: k,
      tabIndex: m,
      disableRipple: C,
      ...he,
      children: [
        typeof n == "string" && y ? n.toLowerCase() : n,
        v ? /* @__PURE__ */ l(Aa, { className: fe }) : null
      ]
    }
  );
}
const _r = et(Or), Je = _r;
function Pt(e) {
  const [t, n] = E(e), a = Ie(() => {
    n(!0);
  }, []), r = Ie(() => {
    n(!1);
  }, []), o = Ie(() => {
    n((i) => !i);
  }, []);
  return [t, a, r, o];
}
const Ol = (e, t) => {
  const [n, a] = E({ width: 0, height: 0 });
  return Q(() => {
    if (e != null && e.current && t && window.ResizeObserver) {
      const r = new ResizeObserver((o) => {
        o.forEach((i) => {
          a({
            width: i.contentRect.width,
            height: i.contentRect.height
          });
        });
      });
      return r.observe(e.current), () => {
        r.disconnect();
      };
    }
    return () => {
    };
  }, [e]), n;
}, Pr = "Do MMM YYYY", on = [
  { short: "Jan", long: "January" },
  { short: "Feb", long: "February" },
  { short: "Mar", long: "March" },
  { short: "Apr", long: "April" },
  { short: "May", long: "May" },
  { short: "Jun", long: "June" },
  { short: "Jul", long: "July" },
  { short: "Aug", long: "August" },
  { short: "Sep", long: "September" },
  { short: "Oct", long: "October" },
  { short: "Nov", long: "November" },
  { short: "Dec", long: "December" }
];
function le(e, t) {
  const n = e.setHours(0, 0, 0, 0), a = t.setHours(0, 0, 0, 0);
  return n === a ? 0 : n < a ? -1 : 1;
}
function Ye(e, t) {
  return le(e, t) === 0;
}
const ge = (e, t = Pr) => Mt(e).format(t), Fr = (e, t = !1) => {
  let r = e.sort(
    (o, i) => new Date(o).getTime() - new Date(i).getTime()
  ).reduce(function(o, i) {
    const s = Mt(i);
    return o.some((c) => {
      const u = s.clone().subtract(1, "day"), f = s.clone().add(1, "day");
      return c[u.toDate().toString()] || c[f.toDate().toString()] ? (c[i.toString()] = !0, !0) : !1;
    }) || o.push({ [i.toString()]: !0 }), o;
  }, []);
  return r = r.map((o) => {
    const i = Object.keys(o);
    return t && i.length === 1 && i.push(i[0]), i;
  }), r;
};
function sn(e, t = "days", n = /* @__PURE__ */ new Date()) {
  const a = Mt(n).add(e, t).toDate();
  return new Date(a);
}
const Ir = (e, t) => {
  const n = { ...e.month }, a = { ...e.year }, r = t.getMonth(), o = t.getFullYear(), i = `${o}-${r}`;
  return n[i] -= 1, a[o] -= 1, {
    month: n,
    year: a,
    count: e.count - 1
  };
}, Tn = (e, t) => {
  const n = { ...e.month }, a = { ...e.year }, r = t.getMonth(), o = t.getFullYear(), i = `${o}-${r}`;
  return n[i] ? n[i] += 1 : n[i] = 1, a[o] ? a[o] += 1 : a[o] = 1, {
    month: n,
    year: a,
    count: e.count + 1
  };
}, Rr = (e, t, n) => {
  const {
    month: a,
    year: r,
    total: o
  } = e;
  if (o && o < t.count)
    return !0;
  const i = n.getMonth(), s = n.getFullYear(), d = `${s}-${i}`;
  if (r === void 0 && a === void 0)
    return !1;
  const { month: c, year: u } = t;
  return (c == null ? void 0 : c[d]) >= a || (u == null ? void 0 : u[s]) >= r;
}, Tr = (e, t, n) => {
  const a = [...n], { month: r, year: o, count: i } = t, s = i - n[e].length;
  return n[e].forEach((c) => {
    const u = new Date(c), f = u.getMonth(), h = u.getFullYear(), m = `${h}-${f}`;
    r[m] = r[m] - 1, o[h] = o[h] - 1;
  }), a.splice(e, 1), [a.reduce((c, u) => [...c, ...u.map((f) => new Date(f))], []), { month: r, year: o, count: s }];
}, Wr = (e) => {
  const t = {
    month: {},
    year: {},
    count: 0
  };
  return e.reduce(
    (a, r) => Tn(a, r),
    t
  );
}, _l = (e) => {
  const t = /* @__PURE__ */ new Date(), {
    initialDate: n,
    callbackAfterDateSelection: a,
    defaultNull: r = !0,
    multiSelectRestriction: o = {}
  } = e || {}, [i, s, d] = Pt(!1), [c, u] = E(
    n || (r ? [] : [t])
  ), [f, h] = E(), [m, p] = E(
    () => Wr(c)
  ), b = (x, { disabled: y, selected: C }, N) => {
    if (y)
      return;
    const M = [...c];
    if (C) {
      const I = M.findIndex(
        (T) => le(T, x) === 0
      );
      M.splice(I, 1), p(Ir(m, x));
    } else
      Rr(o, m, x) || (M.push(x), p(Tn(m, x)));
    u(M), a == null || a(M);
  }, v = (x, y) => {
    const [C, N] = Tr(
      x,
      m,
      y
    );
    p(N), u(C), a == null || a(C);
  };
  return {
    calendarProps: {
      variant: "multiple",
      selectedDays: c,
      setSelectedDays: u,
      handleDayClick: b,
      month: f,
      setMonth: h,
      initialMonth: c[0] ?? t,
      selectedDateMeta: m,
      setSelectedDateMeta: p,
      handleRemoveMultipleDates: v
    },
    popoverState: {
      isCalendarOpen: i,
      showCalendar: s,
      hideCalendar: d
    }
  };
}, Er = (e) => {
  const {
    initialDate: t = { from: null, to: null },
    callbackAfterDateSelection: n = () => {
    },
    allowEmptyRange: a = !1
  } = e || {}, [r, o, i] = Pt(!1), [s, d] = E(t), [c, u] = E(), [f, h] = E(
    "FROM"
  ), [m, p] = E(!0), [b, v] = E(!0), x = (M) => s.from && s.to ? le(M, s.to) > 0 ? { ...s, to: M } : le(M, s.from) < 0 ? { ...s, from: M } : { from: M, to: null } : s.from ? le(M, s.from) < 0 ? { from: M, to: s.from } : { ...s, to: M } : { from: M, to: null }, y = (M, { disabled: I }, T) => {
    if (I)
      return;
    let R = { ...s };
    a && s.from && s.to && le(M, s.from) > 0 && le(M, s.to) < 0 ? (R = { from: null, to: null }, p(!0)) : m ? (p(!1), R = { from: M, to: null }) : R = x(M), d(R), n == null || n(R);
  }, C = (M, { disabled: I }, T) => {
    if (I)
      return;
    let R = { ...s };
    b ? (v(!1), s.from ? le(M, s.from) > 0 ? R = { from: s.from, to: M } : R = { from: M, to: null } : R = { from: M, to: null }) : R = x(M), d(R), n == null || n(R);
  }, N = (M) => {
    d(M), n == null || n(M);
  };
  return {
    calendarProps: {
      variant: "range",
      initialMonth: s.from ?? /* @__PURE__ */ new Date(),
      selectedDays: s,
      setSelectedDays: d,
      month: c,
      setMonth: u,
      setRange: N,
      handleFromDayClick: y,
      handleToDayClick: C,
      setIsFirstClickInFromInput: p,
      setIsFirstClickInToInput: v,
      inputBoxSelected: f,
      setInputBoxSelected: h
    },
    popoverState: { isCalendarOpen: r, showCalendar: o, hideCalendar: i }
  };
}, Pl = (e) => {
  const t = /* @__PURE__ */ new Date(), {
    initialDate: n,
    callbackAfterDateSelection: a,
    defaultNull: r = !1
  } = e || {}, [o, i, s] = Pt(!1), [d, c] = E(
    n || (r ? null : t)
  ), [u, f] = E();
  return {
    calendarProps: {
      variant: "single",
      selectedDays: d,
      setSelectedDays: c,
      handleDayClick: (m, { disabled: p = !1 }, b) => {
        p || (c(m), a == null || a(m));
      },
      month: u,
      setMonth: f,
      initialMonth: d ?? t
    },
    popoverState: {
      isCalendarOpen: o,
      showCalendar: i,
      hideCalendar: s
    }
  };
};
function _(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function K(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function j(e, t) {
  const n = _(e);
  return isNaN(t) ? K(e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function re(e, t) {
  const n = _(e);
  if (isNaN(t))
    return K(e, NaN);
  if (!t)
    return n;
  const a = n.getDate(), r = K(e, n.getTime());
  r.setMonth(n.getMonth() + t + 1, 0);
  const o = r.getDate();
  return a >= o ? r : (n.setFullYear(
    r.getFullYear(),
    r.getMonth(),
    a
  ), n);
}
const Ft = 6048e5, Br = 864e5, Fl = 6e4, Il = 36e5, Rl = 1e3;
let Lr = {};
function Ae() {
  return Lr;
}
function ue(e, t) {
  var s, d, c, u;
  const n = Ae(), a = (t == null ? void 0 : t.weekStartsOn) ?? ((d = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : d.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, r = _(e), o = r.getDay(), i = (o < a ? 7 : 0) + o - a;
  return r.setDate(r.getDate() - i), r.setHours(0, 0, 0, 0), r;
}
function Se(e) {
  return ue(e, { weekStartsOn: 1 });
}
function Wn(e) {
  const t = _(e), n = t.getFullYear(), a = K(e, 0);
  a.setFullYear(n + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const r = Se(a), o = K(e, 0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  const i = Se(o);
  return t.getTime() >= r.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function Re(e) {
  const t = _(e);
  return t.setHours(0, 0, 0, 0), t;
}
function Ke(e) {
  const t = _(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function ce(e, t) {
  const n = Re(e), a = Re(t), r = +n - Ke(n), o = +a - Ke(a);
  return Math.round((r - o) / Br);
}
function Yr(e) {
  const t = Wn(e), n = K(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), Se(n);
}
function xt(e, t) {
  const n = t * 7;
  return j(e, n);
}
function $r(e, t) {
  return re(e, t * 12);
}
function zr(e) {
  let t;
  return e.forEach(function(n) {
    const a = _(n);
    (t === void 0 || t < a || isNaN(Number(a))) && (t = a);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function Ar(e) {
  let t;
  return e.forEach((n) => {
    const a = _(n);
    (!t || t > a || isNaN(+a)) && (t = a);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function U(e, t) {
  const n = Re(e), a = Re(t);
  return +n == +a;
}
function It(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Hr(e) {
  if (!It(e) && typeof e != "number")
    return !1;
  const t = _(e);
  return !isNaN(Number(t));
}
function $e(e, t) {
  const n = _(e), a = _(t), r = n.getFullYear() - a.getFullYear(), o = n.getMonth() - a.getMonth();
  return r * 12 + o;
}
function Vr(e, t, n) {
  const a = ue(e, n), r = ue(t, n), o = +a - Ke(a), i = +r - Ke(r);
  return Math.round((o - i) / Ft);
}
function Rt(e) {
  const t = _(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function G(e) {
  const t = _(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function En(e) {
  const t = _(e), n = K(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Tt(e, t) {
  var s, d, c, u;
  const n = Ae(), a = (t == null ? void 0 : t.weekStartsOn) ?? ((d = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : d.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, r = _(e), o = r.getDay(), i = (o < a ? -7 : 0) + 6 - (o - a);
  return r.setDate(r.getDate() + i), r.setHours(23, 59, 59, 999), r;
}
function Bn(e) {
  return Tt(e, { weekStartsOn: 1 });
}
const jr = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, qr = (e, t, n) => {
  let a;
  const r = jr[e];
  return typeof r == "string" ? a = r : t === 1 ? a = r.one : a = r.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
function ft(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const Ur = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Gr = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Xr = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Qr = {
  date: ft({
    formats: Ur,
    defaultWidth: "full"
  }),
  time: ft({
    formats: Gr,
    defaultWidth: "full"
  }),
  dateTime: ft({
    formats: Xr,
    defaultWidth: "full"
  })
}, Jr = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Kr = (e, t, n, a) => Jr[e];
function Be(e) {
  return (t, n) => {
    const a = n != null && n.context ? String(n.context) : "standalone";
    let r;
    if (a === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : i;
      r = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      r = e.values[s] || e.values[i];
    }
    const o = e.argumentCallback ? e.argumentCallback(t) : t;
    return r[o];
  };
}
const Zr = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, eo = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, to = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, no = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, ao = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, ro = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, oo = (e, t) => {
  const n = Number(e), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, io = {
  ordinalNumber: oo,
  era: Be({
    values: Zr,
    defaultWidth: "wide"
  }),
  quarter: Be({
    values: eo,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Be({
    values: to,
    defaultWidth: "wide"
  }),
  day: Be({
    values: no,
    defaultWidth: "wide"
  }),
  dayPeriod: Be({
    values: ao,
    defaultWidth: "wide",
    formattingValues: ro,
    defaultFormattingWidth: "wide"
  })
};
function Le(e) {
  return (t, n = {}) => {
    const a = n.width, r = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], o = t.match(r);
    if (!o)
      return null;
    const i = o[0], s = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], d = Array.isArray(s) ? lo(s, (f) => f.test(i)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      so(s, (f) => f.test(i))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(d) : d, c = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = t.slice(i.length);
    return { value: c, rest: u };
  };
}
function so(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function lo(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function co(e) {
  return (t, n = {}) => {
    const a = t.match(e.matchPattern);
    if (!a)
      return null;
    const r = a[0], o = t.match(e.parsePattern);
    if (!o)
      return null;
    let i = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const s = t.slice(r.length);
    return { value: i, rest: s };
  };
}
const uo = /^(\d+)(th|st|nd|rd)?/i, fo = /\d+/i, ho = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, mo = {
  any: [/^b/i, /^(a|c)/i]
}, po = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, go = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, vo = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, bo = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, yo = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, xo = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, wo = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Co = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, ko = {
  ordinalNumber: co({
    matchPattern: uo,
    parsePattern: fo,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Le({
    matchPatterns: ho,
    defaultMatchWidth: "wide",
    parsePatterns: mo,
    defaultParseWidth: "any"
  }),
  quarter: Le({
    matchPatterns: po,
    defaultMatchWidth: "wide",
    parsePatterns: go,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Le({
    matchPatterns: vo,
    defaultMatchWidth: "wide",
    parsePatterns: bo,
    defaultParseWidth: "any"
  }),
  day: Le({
    matchPatterns: yo,
    defaultMatchWidth: "wide",
    parsePatterns: xo,
    defaultParseWidth: "any"
  }),
  dayPeriod: Le({
    matchPatterns: wo,
    defaultMatchWidth: "any",
    parsePatterns: Co,
    defaultParseWidth: "any"
  })
}, Ln = {
  code: "en-US",
  formatDistance: qr,
  formatLong: Qr,
  formatRelative: Kr,
  localize: io,
  match: ko,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Do(e) {
  const t = _(e);
  return ce(t, En(t)) + 1;
}
function Yn(e) {
  const t = _(e), n = +Se(t) - +Yr(t);
  return Math.round(n / Ft) + 1;
}
function $n(e, t) {
  var u, f, h, m;
  const n = _(e), a = n.getFullYear(), r = Ae(), o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : f.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((m = (h = r.locale) == null ? void 0 : h.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, i = K(e, 0);
  i.setFullYear(a + 1, 0, o), i.setHours(0, 0, 0, 0);
  const s = ue(i, t), d = K(e, 0);
  d.setFullYear(a, 0, o), d.setHours(0, 0, 0, 0);
  const c = ue(d, t);
  return n.getTime() >= s.getTime() ? a + 1 : n.getTime() >= c.getTime() ? a : a - 1;
}
function Mo(e, t) {
  var s, d, c, u;
  const n = Ae(), a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : d.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, r = $n(e, t), o = K(e, 0);
  return o.setFullYear(r, 0, a), o.setHours(0, 0, 0, 0), ue(o, t);
}
function zn(e, t) {
  const n = _(e), a = +ue(n, t) - +Mo(n, t);
  return Math.round(a / Ft) + 1;
}
function F(e, t) {
  const n = e < 0 ? "-" : "", a = Math.abs(e).toString().padStart(t, "0");
  return n + a;
}
const ye = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), a = n > 0 ? n : 1 - n;
    return F(t === "yy" ? a % 100 : a, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : F(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return F(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return F(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return F(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return F(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return F(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, a = e.getMilliseconds(), r = Math.trunc(
      a * Math.pow(10, n - 3)
    );
    return F(r, t.length);
  }
}, Fe = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, ln = {
  // Era
  G: function(e, t, n) {
    const a = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, { width: "abbreviated" });
      case "GGGGG":
        return n.era(a, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const a = e.getFullYear(), r = a > 0 ? a : 1 - a;
      return n.ordinalNumber(r, { unit: "year" });
    }
    return ye.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, a) {
    const r = $n(e, a), o = r > 0 ? r : 1 - r;
    if (t === "YY") {
      const i = o % 100;
      return F(i, 2);
    }
    return t === "Yo" ? n.ordinalNumber(o, { unit: "year" }) : F(o, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = Wn(e);
    return F(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return F(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(a);
      case "QQ":
        return F(a, 2);
      case "Qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(a);
      case "qq":
        return F(a, 2);
      case "qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const a = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return ye.M(e, t);
      case "Mo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const a = e.getMonth();
    switch (t) {
      case "L":
        return String(a + 1);
      case "LL":
        return F(a + 1, 2);
      case "Lo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, a) {
    const r = zn(e, a);
    return t === "wo" ? n.ordinalNumber(r, { unit: "week" }) : F(r, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const a = Yn(e);
    return t === "Io" ? n.ordinalNumber(a, { unit: "week" }) : F(a, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : ye.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const a = Do(e);
    return t === "Do" ? n.ordinalNumber(a, { unit: "dayOfYear" }) : F(a, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const a = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, a) {
    const r = e.getDay(), o = (r - a.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(o);
      case "ee":
        return F(o, 2);
      case "eo":
        return n.ordinalNumber(o, { unit: "day" });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, a) {
    const r = e.getDay(), o = (r - a.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(o);
      case "cc":
        return F(o, t.length);
      case "co":
        return n.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const a = e.getDay(), r = a === 0 ? 7 : a;
    switch (t) {
      case "i":
        return String(r);
      case "ii":
        return F(r, t.length);
      case "io":
        return n.ordinalNumber(r, { unit: "day" });
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const a = e.getHours();
    let r;
    switch (a === 12 ? r = Fe.noon : a === 0 ? r = Fe.midnight : r = a / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const a = e.getHours();
    let r;
    switch (a >= 17 ? r = Fe.evening : a >= 12 ? r = Fe.afternoon : a >= 4 ? r = Fe.morning : r = Fe.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let a = e.getHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, { unit: "hour" });
    }
    return ye.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : ye.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const a = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(a, { unit: "hour" }) : F(a, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let a = e.getHours();
    return a === 0 && (a = 24), t === "ko" ? n.ordinalNumber(a, { unit: "hour" }) : F(a, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : ye.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : ye.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return ye.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const a = e.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (t) {
      case "X":
        return dn(a);
      case "XXXX":
      case "XX":
        return Me(a);
      case "XXXXX":
      case "XXX":
      default:
        return Me(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const a = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return dn(a);
      case "xxxx":
      case "xx":
        return Me(a);
      case "xxxxx":
      case "xxx":
      default:
        return Me(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const a = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + cn(a, ":");
      case "OOOO":
      default:
        return "GMT" + Me(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const a = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + cn(a, ":");
      case "zzzz":
      default:
        return "GMT" + Me(a, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const a = Math.trunc(e.getTime() / 1e3);
    return F(a, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const a = e.getTime();
    return F(a, t.length);
  }
};
function cn(e, t = "") {
  const n = e > 0 ? "-" : "+", a = Math.abs(e), r = Math.trunc(a / 60), o = a % 60;
  return o === 0 ? n + String(r) : n + String(r) + t + F(o, 2);
}
function dn(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + F(Math.abs(e) / 60, 2) : Me(e, t);
}
function Me(e, t = "") {
  const n = e > 0 ? "-" : "+", a = Math.abs(e), r = F(Math.trunc(a / 60), 2), o = F(a % 60, 2);
  return n + r + t + o;
}
const un = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, An = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, So = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], a = n[1], r = n[2];
  if (!r)
    return un(e, t);
  let o;
  switch (a) {
    case "P":
      o = t.dateTime({ width: "short" });
      break;
    case "PP":
      o = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = t.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", un(a, t)).replace("{{time}}", An(r, t));
}, No = {
  p: An,
  P: So
}, Oo = /^D+$/, _o = /^Y+$/, Po = ["D", "DD", "YY", "YYYY"];
function Fo(e) {
  return Oo.test(e);
}
function Io(e) {
  return _o.test(e);
}
function Ro(e, t, n) {
  const a = To(e, t, n);
  if (console.warn(a), Po.includes(e))
    throw new RangeError(a);
}
function To(e, t, n) {
  const a = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${a} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Wo = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Eo = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Bo = /^'([^]*?)'?$/, Lo = /''/g, Yo = /[a-zA-Z]/;
function _e(e, t, n) {
  var u, f, h, m, p, b, v, x;
  const a = Ae(), r = (n == null ? void 0 : n.locale) ?? a.locale ?? Ln, o = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((f = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : f.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((m = (h = a.locale) == null ? void 0 : h.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, i = (n == null ? void 0 : n.weekStartsOn) ?? ((b = (p = n == null ? void 0 : n.locale) == null ? void 0 : p.options) == null ? void 0 : b.weekStartsOn) ?? a.weekStartsOn ?? ((x = (v = a.locale) == null ? void 0 : v.options) == null ? void 0 : x.weekStartsOn) ?? 0, s = _(e);
  if (!Hr(s))
    throw new RangeError("Invalid time value");
  let d = t.match(Eo).map((y) => {
    const C = y[0];
    if (C === "p" || C === "P") {
      const N = No[C];
      return N(y, r.formatLong);
    }
    return y;
  }).join("").match(Wo).map((y) => {
    if (y === "''")
      return { isToken: !1, value: "'" };
    const C = y[0];
    if (C === "'")
      return { isToken: !1, value: $o(y) };
    if (ln[C])
      return { isToken: !0, value: y };
    if (C.match(Yo))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + C + "`"
      );
    return { isToken: !1, value: y };
  });
  r.localize.preprocessor && (d = r.localize.preprocessor(s, d));
  const c = {
    firstWeekContainsDate: o,
    weekStartsOn: i,
    locale: r
  };
  return d.map((y) => {
    if (!y.isToken)
      return y.value;
    const C = y.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && Io(C) || !(n != null && n.useAdditionalDayOfYearTokens) && Fo(C)) && Ro(C, t, String(e));
    const N = ln[C[0]];
    return N(s, C, r.localize, c);
  }).join("");
}
function $o(e) {
  const t = e.match(Bo);
  return t ? t[1].replace(Lo, "'") : e;
}
function zo(e) {
  const t = _(e), n = t.getFullYear(), a = t.getMonth(), r = K(e, 0);
  return r.setFullYear(n, a + 1, 0), r.setHours(0, 0, 0, 0), r.getDate();
}
function Ao(e) {
  return Math.trunc(+_(e) / 1e3);
}
function Ho(e) {
  const t = _(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function Vo(e, t) {
  return Vr(
    Ho(e),
    G(e),
    t
  ) + 1;
}
function wt(e, t) {
  const n = _(e), a = _(t);
  return n.getTime() > a.getTime();
}
function Hn(e, t) {
  const n = _(e), a = _(t);
  return +n < +a;
}
function Wt(e, t) {
  const n = _(e), a = _(t);
  return n.getFullYear() === a.getFullYear() && n.getMonth() === a.getMonth();
}
function jo(e, t) {
  const n = _(e), a = _(t);
  return n.getFullYear() === a.getFullYear();
}
function ht(e, t) {
  return j(e, -t);
}
function mt(e, t) {
  const n = _(e), a = n.getFullYear(), r = n.getDate(), o = K(e, 0);
  o.setFullYear(a, t, 15), o.setHours(0, 0, 0, 0);
  const i = zo(o);
  return n.setMonth(t, Math.min(r, i)), n;
}
function fn(e, t) {
  const n = _(e);
  return isNaN(+n) ? K(e, NaN) : (n.setFullYear(t), n);
}
var D = function() {
  return D = Object.assign || function(t) {
    for (var n, a = 1, r = arguments.length; a < r; a++) {
      n = arguments[a];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, D.apply(this, arguments);
};
function qo(e, t) {
  var n = {};
  for (var a in e)
    Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, a = Object.getOwnPropertySymbols(e); r < a.length; r++)
      t.indexOf(a[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[r]) && (n[a[r]] = e[a[r]]);
  return n;
}
function Vn(e, t, n) {
  if (n || arguments.length === 2)
    for (var a = 0, r = t.length, o; a < r; a++)
      (o || !(a in t)) && (o || (o = Array.prototype.slice.call(t, 0, a)), o[a] = t[a]);
  return e.concat(o || Array.prototype.slice.call(t));
}
function He(e) {
  return e.mode === "multiple";
}
function Ve(e) {
  return e.mode === "range";
}
function it(e) {
  return e.mode === "single";
}
var Uo = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function Go(e, t) {
  return _e(e, "LLLL y", t);
}
function Xo(e, t) {
  return _e(e, "d", t);
}
function Qo(e, t) {
  return _e(e, "LLLL", t);
}
function Jo(e) {
  return "".concat(e);
}
function Ko(e, t) {
  return _e(e, "cccccc", t);
}
function Zo(e, t) {
  return _e(e, "yyyy", t);
}
var ei = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: Go,
  formatDay: Xo,
  formatMonthCaption: Qo,
  formatWeekNumber: Jo,
  formatWeekdayName: Ko,
  formatYearCaption: Zo
}), ti = function(e, t, n) {
  return _e(e, "do MMMM (EEEE)", n);
}, ni = function() {
  return "Month: ";
}, ai = function() {
  return "Go to next month";
}, ri = function() {
  return "Go to previous month";
}, oi = function(e, t) {
  return _e(e, "cccc", t);
}, ii = function(e) {
  return "Week n. ".concat(e);
}, si = function() {
  return "Year: ";
}, li = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: ti,
  labelMonthDropdown: ni,
  labelNext: ai,
  labelPrevious: ri,
  labelWeekNumber: ii,
  labelWeekday: oi,
  labelYearDropdown: si
});
function ci() {
  var e = "buttons", t = Uo, n = Ln, a = {}, r = {}, o = 1, i = {}, s = /* @__PURE__ */ new Date();
  return {
    captionLayout: e,
    classNames: t,
    formatters: ei,
    labels: li,
    locale: n,
    modifiersClassNames: a,
    modifiers: r,
    numberOfMonths: o,
    styles: i,
    today: s,
    mode: "default"
  };
}
function di(e) {
  var t = e.fromYear, n = e.toYear, a = e.fromMonth, r = e.toMonth, o = e.fromDate, i = e.toDate;
  return a ? o = G(a) : t && (o = new Date(t, 0, 1)), r ? i = Rt(r) : n && (i = new Date(n, 11, 31)), {
    fromDate: o ? Re(o) : void 0,
    toDate: i ? Re(i) : void 0
  };
}
var jn = Ne(void 0);
function ui(e) {
  var t, n = e.initialProps, a = ci(), r = di(n), o = r.fromDate, i = r.toDate, s = (t = n.captionLayout) !== null && t !== void 0 ? t : a.captionLayout;
  s !== "buttons" && (!o || !i) && (s = "buttons");
  var d;
  (it(n) || He(n) || Ve(n)) && (d = n.onSelect);
  var c = D(D(D({}, a), n), { captionLayout: s, classNames: D(D({}, a.classNames), n.classNames), components: D({}, n.components), formatters: D(D({}, a.formatters), n.formatters), fromDate: o, labels: D(D({}, a.labels), n.labels), mode: n.mode || a.mode, modifiers: D(D({}, a.modifiers), n.modifiers), modifiersClassNames: D(D({}, a.modifiersClassNames), n.modifiersClassNames), onSelect: d, styles: D(D({}, a.styles), n.styles), toDate: i });
  return l(jn.Provider, { value: c, children: e.children });
}
function W() {
  var e = Oe(jn);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function qn(e) {
  var t = W(), n = t.locale, a = t.classNames, r = t.styles, o = t.formatters.formatCaption;
  return l("div", { className: a.caption_label, style: r.caption_label, "aria-live": "polite", role: "presentation", id: e.id, children: o(e.displayMonth, { locale: n }) });
}
function fi(e) {
  return l("svg", D({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, e, { children: l("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function Un(e) {
  var t, n, a = e.onChange, r = e.value, o = e.children, i = e.caption, s = e.className, d = e.style, c = W(), u = (n = (t = c.components) === null || t === void 0 ? void 0 : t.IconDropdown) !== null && n !== void 0 ? n : fi;
  return S("div", { className: s, style: d, children: [l("span", { className: c.classNames.vhidden, children: e["aria-label"] }), l("select", { name: e.name, "aria-label": e["aria-label"], className: c.classNames.dropdown, style: c.styles.dropdown, value: r, onChange: a, children: o }), S("div", { className: c.classNames.caption_label, style: c.styles.caption_label, "aria-hidden": "true", children: [i, l(u, { className: c.classNames.dropdown_icon, style: c.styles.dropdown_icon })] })] });
}
function hi(e) {
  var t, n = W(), a = n.fromDate, r = n.toDate, o = n.styles, i = n.locale, s = n.formatters.formatMonthCaption, d = n.classNames, c = n.components, u = n.labels.labelMonthDropdown;
  if (!a)
    return l(ee, {});
  if (!r)
    return l(ee, {});
  var f = [];
  if (jo(a, r))
    for (var h = G(a), m = a.getMonth(); m <= r.getMonth(); m++)
      f.push(mt(h, m));
  else
    for (var h = G(/* @__PURE__ */ new Date()), m = 0; m <= 11; m++)
      f.push(mt(h, m));
  var p = function(v) {
    var x = Number(v.target.value), y = mt(G(e.displayMonth), x);
    e.onChange(y);
  }, b = (t = c == null ? void 0 : c.Dropdown) !== null && t !== void 0 ? t : Un;
  return l(b, { name: "months", "aria-label": u(), className: d.dropdown_month, style: o.dropdown_month, onChange: p, value: e.displayMonth.getMonth(), caption: s(e.displayMonth, { locale: i }), children: f.map(function(v) {
    return l("option", { value: v.getMonth(), children: s(v, { locale: i }) }, v.getMonth());
  }) });
}
function mi(e) {
  var t, n = e.displayMonth, a = W(), r = a.fromDate, o = a.toDate, i = a.locale, s = a.styles, d = a.classNames, c = a.components, u = a.formatters.formatYearCaption, f = a.labels.labelYearDropdown, h = [];
  if (!r)
    return l(ee, {});
  if (!o)
    return l(ee, {});
  for (var m = r.getFullYear(), p = o.getFullYear(), b = m; b <= p; b++)
    h.push(fn(En(/* @__PURE__ */ new Date()), b));
  var v = function(y) {
    var C = fn(G(n), Number(y.target.value));
    e.onChange(C);
  }, x = (t = c == null ? void 0 : c.Dropdown) !== null && t !== void 0 ? t : Un;
  return l(x, { name: "years", "aria-label": f(), className: d.dropdown_year, style: s.dropdown_year, onChange: v, value: n.getFullYear(), caption: u(n, { locale: i }), children: h.map(function(y) {
    return l("option", { value: y.getFullYear(), children: u(y, { locale: i }) }, y.getFullYear());
  }) });
}
function pi(e, t) {
  var n = E(e), a = n[0], r = n[1], o = t === void 0 ? a : t;
  return [o, r];
}
function gi(e) {
  var t = e.month, n = e.defaultMonth, a = e.today, r = t || n || a || /* @__PURE__ */ new Date(), o = e.toDate, i = e.fromDate, s = e.numberOfMonths, d = s === void 0 ? 1 : s;
  if (o && $e(o, r) < 0) {
    var c = -1 * (d - 1);
    r = re(o, c);
  }
  return i && $e(r, i) < 0 && (r = i), G(r);
}
function vi() {
  var e = W(), t = gi(e), n = pi(t, e.month), a = n[0], r = n[1], o = function(i) {
    var s;
    if (!e.disableNavigation) {
      var d = G(i);
      r(d), (s = e.onMonthChange) === null || s === void 0 || s.call(e, d);
    }
  };
  return [a, o];
}
function bi(e, t) {
  for (var n = t.reverseMonths, a = t.numberOfMonths, r = G(e), o = G(re(r, a)), i = $e(o, r), s = [], d = 0; d < i; d++) {
    var c = re(r, d);
    s.push(c);
  }
  return n && (s = s.reverse()), s;
}
function yi(e, t) {
  if (!t.disableNavigation) {
    var n = t.toDate, a = t.pagedNavigation, r = t.numberOfMonths, o = r === void 0 ? 1 : r, i = a ? o : 1, s = G(e);
    if (!n)
      return re(s, i);
    var d = $e(n, e);
    if (!(d < o))
      return re(s, i);
  }
}
function xi(e, t) {
  if (!t.disableNavigation) {
    var n = t.fromDate, a = t.pagedNavigation, r = t.numberOfMonths, o = r === void 0 ? 1 : r, i = a ? o : 1, s = G(e);
    if (!n)
      return re(s, -i);
    var d = $e(s, n);
    if (!(d <= 0))
      return re(s, -i);
  }
}
var Gn = Ne(void 0);
function wi(e) {
  var t = W(), n = vi(), a = n[0], r = n[1], o = bi(a, t), i = yi(a, t), s = xi(a, t), d = function(f) {
    return o.some(function(h) {
      return Wt(f, h);
    });
  }, c = function(f, h) {
    d(f) || (h && Hn(f, h) ? r(re(f, 1 + t.numberOfMonths * -1)) : r(f));
  }, u = {
    currentMonth: a,
    displayMonths: o,
    goToMonth: r,
    goToDate: c,
    previousMonth: s,
    nextMonth: i,
    isDateDisplayed: d
  };
  return l(Gn.Provider, { value: u, children: e.children });
}
function We() {
  var e = Oe(Gn);
  if (!e)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function hn(e) {
  var t, n = W(), a = n.classNames, r = n.styles, o = n.components, i = We().goToMonth, s = function(u) {
    i(re(u, e.displayIndex ? -e.displayIndex : 0));
  }, d = (t = o == null ? void 0 : o.CaptionLabel) !== null && t !== void 0 ? t : qn, c = l(d, { id: e.id, displayMonth: e.displayMonth });
  return S("div", { className: a.caption_dropdowns, style: r.caption_dropdowns, children: [l("div", { className: a.vhidden, children: c }), l(hi, { onChange: s, displayMonth: e.displayMonth }), l(mi, { onChange: s, displayMonth: e.displayMonth })] });
}
function Ci(e) {
  return l("svg", D({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: l("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function ki(e) {
  return l("svg", D({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: l("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var Ze = et(function(e, t) {
  var n = W(), a = n.classNames, r = n.styles, o = [a.button_reset, a.button];
  e.className && o.push(e.className);
  var i = o.join(" "), s = D(D({}, r.button_reset), r.button);
  return e.style && Object.assign(s, e.style), l("button", D({}, e, { ref: t, type: "button", className: i, style: s }));
});
function Di(e) {
  var t, n, a = W(), r = a.dir, o = a.locale, i = a.classNames, s = a.styles, d = a.labels, c = d.labelPrevious, u = d.labelNext, f = a.components;
  if (!e.nextMonth && !e.previousMonth)
    return l(ee, {});
  var h = c(e.previousMonth, { locale: o }), m = [
    i.nav_button,
    i.nav_button_previous
  ].join(" "), p = u(e.nextMonth, { locale: o }), b = [
    i.nav_button,
    i.nav_button_next
  ].join(" "), v = (t = f == null ? void 0 : f.IconRight) !== null && t !== void 0 ? t : ki, x = (n = f == null ? void 0 : f.IconLeft) !== null && n !== void 0 ? n : Ci;
  return S("div", { className: i.nav, style: s.nav, children: [!e.hidePrevious && l(Ze, { name: "previous-month", "aria-label": h, className: m, style: s.nav_button_previous, disabled: !e.previousMonth, onClick: e.onPreviousClick, children: r === "rtl" ? l(v, { className: i.nav_icon, style: s.nav_icon }) : l(x, { className: i.nav_icon, style: s.nav_icon }) }), !e.hideNext && l(Ze, { name: "next-month", "aria-label": p, className: b, style: s.nav_button_next, disabled: !e.nextMonth, onClick: e.onNextClick, children: r === "rtl" ? l(x, { className: i.nav_icon, style: s.nav_icon }) : l(v, { className: i.nav_icon, style: s.nav_icon }) })] });
}
function mn(e) {
  var t = W().numberOfMonths, n = We(), a = n.previousMonth, r = n.nextMonth, o = n.goToMonth, i = n.displayMonths, s = i.findIndex(function(p) {
    return Wt(e.displayMonth, p);
  }), d = s === 0, c = s === i.length - 1, u = t > 1 && (d || !c), f = t > 1 && (c || !d), h = function() {
    a && o(a);
  }, m = function() {
    r && o(r);
  };
  return l(Di, { displayMonth: e.displayMonth, hideNext: u, hidePrevious: f, nextMonth: r, previousMonth: a, onPreviousClick: h, onNextClick: m });
}
function Mi(e) {
  var t, n = W(), a = n.classNames, r = n.disableNavigation, o = n.styles, i = n.captionLayout, s = n.components, d = (t = s == null ? void 0 : s.CaptionLabel) !== null && t !== void 0 ? t : qn, c;
  return r ? c = l(d, { id: e.id, displayMonth: e.displayMonth }) : i === "dropdown" ? c = l(hn, { displayMonth: e.displayMonth, id: e.id }) : i === "dropdown-buttons" ? c = S(ee, { children: [l(hn, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id }), l(mn, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id })] }) : c = S(ee, { children: [l(d, { id: e.id, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), l(mn, { displayMonth: e.displayMonth, id: e.id })] }), l("div", { className: a.caption, style: o.caption, children: c });
}
function Si(e) {
  var t = W(), n = t.footer, a = t.styles, r = t.classNames.tfoot;
  return n ? l("tfoot", { className: r, style: a.tfoot, children: l("tr", { children: l("td", { colSpan: 8, children: n }) }) }) : l(ee, {});
}
function Ni(e, t, n) {
  for (var a = n ? Se(/* @__PURE__ */ new Date()) : ue(/* @__PURE__ */ new Date(), { locale: e, weekStartsOn: t }), r = [], o = 0; o < 7; o++) {
    var i = j(a, o);
    r.push(i);
  }
  return r;
}
function Oi() {
  var e = W(), t = e.classNames, n = e.styles, a = e.showWeekNumber, r = e.locale, o = e.weekStartsOn, i = e.ISOWeek, s = e.formatters.formatWeekdayName, d = e.labels.labelWeekday, c = Ni(r, o, i);
  return S("tr", { style: n.head_row, className: t.head_row, children: [a && l("td", { style: n.head_cell, className: t.head_cell }), c.map(function(u, f) {
    return l("th", { scope: "col", className: t.head_cell, style: n.head_cell, "aria-label": d(u, { locale: r }), children: s(u, { locale: r }) }, f);
  })] });
}
function _i() {
  var e, t = W(), n = t.classNames, a = t.styles, r = t.components, o = (e = r == null ? void 0 : r.HeadRow) !== null && e !== void 0 ? e : Oi;
  return l("thead", { style: a.head, className: n.head, children: l(o, {}) });
}
function Pi(e) {
  var t = W(), n = t.locale, a = t.formatters.formatDay;
  return l(ee, { children: a(e.date, { locale: n }) });
}
var Et = Ne(void 0);
function Fi(e) {
  if (!He(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return l(Et.Provider, { value: t, children: e.children });
  }
  return l(Ii, { initialProps: e.initialProps, children: e.children });
}
function Ii(e) {
  var t = e.initialProps, n = e.children, a = t.selected, r = t.min, o = t.max, i = function(c, u, f) {
    var h, m;
    (h = t.onDayClick) === null || h === void 0 || h.call(t, c, u, f);
    var p = !!(u.selected && r && (a == null ? void 0 : a.length) === r);
    if (!p) {
      var b = !!(!u.selected && o && (a == null ? void 0 : a.length) === o);
      if (!b) {
        var v = a ? Vn([], a, !0) : [];
        if (u.selected) {
          var x = v.findIndex(function(y) {
            return U(c, y);
          });
          v.splice(x, 1);
        } else
          v.push(c);
        (m = t.onSelect) === null || m === void 0 || m.call(t, v, c, u, f);
      }
    }
  }, s = {
    disabled: []
  };
  a && s.disabled.push(function(c) {
    var u = o && a.length > o - 1, f = a.some(function(h) {
      return U(h, c);
    });
    return !!(u && !f);
  });
  var d = {
    selected: a,
    onDayClick: i,
    modifiers: s
  };
  return l(Et.Provider, { value: d, children: n });
}
function Bt() {
  var e = Oe(Et);
  if (!e)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function Ri(e, t) {
  var n = t || {}, a = n.from, r = n.to;
  return a && r ? U(r, e) && U(a, e) ? void 0 : U(r, e) ? { from: r, to: void 0 } : U(a, e) ? void 0 : wt(a, e) ? { from: e, to: r } : { from: a, to: e } : r ? wt(e, r) ? { from: r, to: e } : { from: e, to: r } : a ? Hn(e, a) ? { from: e, to: a } : { from: a, to: e } : { from: e, to: void 0 };
}
var Lt = Ne(void 0);
function Ti(e) {
  if (!Ve(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return l(Lt.Provider, { value: t, children: e.children });
  }
  return l(Wi, { initialProps: e.initialProps, children: e.children });
}
function Wi(e) {
  var t = e.initialProps, n = e.children, a = t.selected, r = a || {}, o = r.from, i = r.to, s = t.min, d = t.max, c = function(m, p, b) {
    var v, x;
    (v = t.onDayClick) === null || v === void 0 || v.call(t, m, p, b);
    var y = Ri(m, a);
    (x = t.onSelect) === null || x === void 0 || x.call(t, y, m, p, b);
  }, u = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (o ? (u.range_start = [o], i ? (u.range_end = [i], U(o, i) || (u.range_middle = [
    {
      after: o,
      before: i
    }
  ])) : u.range_end = [o]) : i && (u.range_start = [i], u.range_end = [i]), s && (o && !i && u.disabled.push({
    after: ht(o, s - 1),
    before: j(o, s - 1)
  }), o && i && u.disabled.push({
    after: o,
    before: j(o, s - 1)
  }), !o && i && u.disabled.push({
    after: ht(i, s - 1),
    before: j(i, s - 1)
  })), d) {
    if (o && !i && (u.disabled.push({
      before: j(o, -d + 1)
    }), u.disabled.push({
      after: j(o, d - 1)
    })), o && i) {
      var f = ce(i, o) + 1, h = d - f;
      u.disabled.push({
        before: ht(o, h)
      }), u.disabled.push({
        after: j(i, h)
      });
    }
    !o && i && (u.disabled.push({
      before: j(i, -d + 1)
    }), u.disabled.push({
      after: j(i, d - 1)
    }));
  }
  return l(Lt.Provider, { value: { selected: a, onDayClick: c, modifiers: u }, children: n });
}
function Yt() {
  var e = Oe(Lt);
  if (!e)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function Qe(e) {
  return Array.isArray(e) ? Vn([], e, !0) : e !== void 0 ? [e] : [];
}
function Ei(e) {
  var t = {};
  return Object.entries(e).forEach(function(n) {
    var a = n[0], r = n[1];
    t[a] = Qe(r);
  }), t;
}
var oe;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(oe || (oe = {}));
var Bi = oe.Selected, pe = oe.Disabled, Li = oe.Hidden, Yi = oe.Today, pt = oe.RangeEnd, gt = oe.RangeMiddle, vt = oe.RangeStart, $i = oe.Outside;
function zi(e, t, n) {
  var a, r = (a = {}, a[Bi] = Qe(e.selected), a[pe] = Qe(e.disabled), a[Li] = Qe(e.hidden), a[Yi] = [e.today], a[pt] = [], a[gt] = [], a[vt] = [], a[$i] = [], a);
  return e.fromDate && r[pe].push({ before: e.fromDate }), e.toDate && r[pe].push({ after: e.toDate }), He(e) ? r[pe] = r[pe].concat(t.modifiers[pe]) : Ve(e) && (r[pe] = r[pe].concat(n.modifiers[pe]), r[vt] = n.modifiers[vt], r[gt] = n.modifiers[gt], r[pt] = n.modifiers[pt]), r;
}
var Xn = Ne(void 0);
function Ai(e) {
  var t = W(), n = Bt(), a = Yt(), r = zi(t, n, a), o = Ei(t.modifiers), i = D(D({}, r), o);
  return l(Xn.Provider, { value: i, children: e.children });
}
function Qn() {
  var e = Oe(Xn);
  if (!e)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function Hi(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function Vi(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function ji(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function qi(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function Ui(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function Gi(e, t) {
  var n, a = t.from, r = t.to;
  if (a && r) {
    var o = ce(r, a) < 0;
    o && (n = [r, a], a = n[0], r = n[1]);
    var i = ce(e, a) >= 0 && ce(r, e) >= 0;
    return i;
  }
  return r ? U(r, e) : a ? U(a, e) : !1;
}
function Xi(e) {
  return It(e);
}
function Qi(e) {
  return Array.isArray(e) && e.every(It);
}
function Ji(e, t) {
  return t.some(function(n) {
    if (typeof n == "boolean")
      return n;
    if (Xi(n))
      return U(e, n);
    if (Qi(n))
      return n.includes(e);
    if (Vi(n))
      return Gi(e, n);
    if (Ui(n))
      return n.dayOfWeek.includes(e.getDay());
    if (Hi(n)) {
      var a = ce(n.before, e), r = ce(n.after, e), o = a > 0, i = r < 0, s = wt(n.before, n.after);
      return s ? i && o : o || i;
    }
    return ji(n) ? ce(e, n.after) > 0 : qi(n) ? ce(n.before, e) > 0 : typeof n == "function" ? n(e) : !1;
  });
}
function $t(e, t, n) {
  var a = Object.keys(t).reduce(function(o, i) {
    var s = t[i];
    return Ji(e, s) && o.push(i), o;
  }, []), r = {};
  return a.forEach(function(o) {
    return r[o] = !0;
  }), n && !Wt(e, n) && (r.outside = !0), r;
}
function Ki(e, t) {
  for (var n = G(e[0]), a = Rt(e[e.length - 1]), r, o, i = n; i <= a; ) {
    var s = $t(i, t), d = !s.disabled && !s.hidden;
    if (!d) {
      i = j(i, 1);
      continue;
    }
    if (s.selected)
      return i;
    s.today && !o && (o = i), r || (r = i), i = j(i, 1);
  }
  return o || r;
}
var Zi = 365;
function Jn(e, t) {
  var n = t.moveBy, a = t.direction, r = t.context, o = t.modifiers, i = t.retry, s = i === void 0 ? { count: 0, lastFocused: e } : i, d = r.weekStartsOn, c = r.fromDate, u = r.toDate, f = r.locale, h = {
    day: j,
    week: xt,
    month: re,
    year: $r,
    startOfWeek: function(v) {
      return r.ISOWeek ? Se(v) : ue(v, { locale: f, weekStartsOn: d });
    },
    endOfWeek: function(v) {
      return r.ISOWeek ? Bn(v) : Tt(v, { locale: f, weekStartsOn: d });
    }
  }, m = h[n](e, a === "after" ? 1 : -1);
  a === "before" && c ? m = zr([c, m]) : a === "after" && u && (m = Ar([u, m]));
  var p = !0;
  if (o) {
    var b = $t(m, o);
    p = !b.disabled && !b.hidden;
  }
  return p ? m : s.count > Zi ? s.lastFocused : Jn(m, {
    moveBy: n,
    direction: a,
    context: r,
    modifiers: o,
    retry: D(D({}, s), { count: s.count + 1 })
  });
}
var Kn = Ne(void 0);
function es(e) {
  var t = We(), n = Qn(), a = E(), r = a[0], o = a[1], i = E(), s = i[0], d = i[1], c = Ki(t.displayMonths, n), u = r ?? (s && t.isDateDisplayed(s)) ? s : c, f = function() {
    d(r), o(void 0);
  }, h = function(v) {
    o(v);
  }, m = W(), p = function(v, x) {
    if (r) {
      var y = Jn(r, {
        moveBy: v,
        direction: x,
        context: m,
        modifiers: n
      });
      U(r, y) || (t.goToDate(y, r), h(y));
    }
  }, b = {
    focusedDay: r,
    focusTarget: u,
    blur: f,
    focus: h,
    focusDayAfter: function() {
      return p("day", "after");
    },
    focusDayBefore: function() {
      return p("day", "before");
    },
    focusWeekAfter: function() {
      return p("week", "after");
    },
    focusWeekBefore: function() {
      return p("week", "before");
    },
    focusMonthBefore: function() {
      return p("month", "before");
    },
    focusMonthAfter: function() {
      return p("month", "after");
    },
    focusYearBefore: function() {
      return p("year", "before");
    },
    focusYearAfter: function() {
      return p("year", "after");
    },
    focusStartOfWeek: function() {
      return p("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return p("endOfWeek", "after");
    }
  };
  return l(Kn.Provider, { value: b, children: e.children });
}
function zt() {
  var e = Oe(Kn);
  if (!e)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function Zn(e, t) {
  var n = Qn(), a = $t(e, n, t);
  return a;
}
var At = Ne(void 0);
function ts(e) {
  if (!it(e.initialProps)) {
    var t = {
      selected: void 0
    };
    return l(At.Provider, { value: t, children: e.children });
  }
  return l(ns, { initialProps: e.initialProps, children: e.children });
}
function ns(e) {
  var t = e.initialProps, n = e.children, a = function(o, i, s) {
    var d, c, u;
    if ((d = t.onDayClick) === null || d === void 0 || d.call(t, o, i, s), i.selected && !t.required) {
      (c = t.onSelect) === null || c === void 0 || c.call(t, void 0, o, i, s);
      return;
    }
    (u = t.onSelect) === null || u === void 0 || u.call(t, o, o, i, s);
  }, r = {
    selected: t.selected,
    onDayClick: a
  };
  return l(At.Provider, { value: r, children: n });
}
function ea() {
  var e = Oe(At);
  if (!e)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function as(e, t) {
  var n = W(), a = ea(), r = Bt(), o = Yt(), i = zt(), s = i.focusDayAfter, d = i.focusDayBefore, c = i.focusWeekAfter, u = i.focusWeekBefore, f = i.blur, h = i.focus, m = i.focusMonthBefore, p = i.focusMonthAfter, b = i.focusYearBefore, v = i.focusYearAfter, x = i.focusStartOfWeek, y = i.focusEndOfWeek, C = function(k) {
    var w, $, ie, se;
    it(n) ? (w = a.onDayClick) === null || w === void 0 || w.call(a, e, t, k) : He(n) ? ($ = r.onDayClick) === null || $ === void 0 || $.call(r, e, t, k) : Ve(n) ? (ie = o.onDayClick) === null || ie === void 0 || ie.call(o, e, t, k) : (se = n.onDayClick) === null || se === void 0 || se.call(n, e, t, k);
  }, N = function(k) {
    var w;
    h(e), (w = n.onDayFocus) === null || w === void 0 || w.call(n, e, t, k);
  }, M = function(k) {
    var w;
    f(), (w = n.onDayBlur) === null || w === void 0 || w.call(n, e, t, k);
  }, I = function(k) {
    var w;
    (w = n.onDayMouseEnter) === null || w === void 0 || w.call(n, e, t, k);
  }, T = function(k) {
    var w;
    (w = n.onDayMouseLeave) === null || w === void 0 || w.call(n, e, t, k);
  }, R = function(k) {
    var w;
    (w = n.onDayPointerEnter) === null || w === void 0 || w.call(n, e, t, k);
  }, A = function(k) {
    var w;
    (w = n.onDayPointerLeave) === null || w === void 0 || w.call(n, e, t, k);
  }, B = function(k) {
    var w;
    (w = n.onDayTouchCancel) === null || w === void 0 || w.call(n, e, t, k);
  }, L = function(k) {
    var w;
    (w = n.onDayTouchEnd) === null || w === void 0 || w.call(n, e, t, k);
  }, H = function(k) {
    var w;
    (w = n.onDayTouchMove) === null || w === void 0 || w.call(n, e, t, k);
  }, fe = function(k) {
    var w;
    (w = n.onDayTouchStart) === null || w === void 0 || w.call(n, e, t, k);
  }, he = function(k) {
    var w;
    (w = n.onDayKeyUp) === null || w === void 0 || w.call(n, e, t, k);
  }, q = function(k) {
    var w;
    switch (k.key) {
      case "ArrowLeft":
        k.preventDefault(), k.stopPropagation(), n.dir === "rtl" ? s() : d();
        break;
      case "ArrowRight":
        k.preventDefault(), k.stopPropagation(), n.dir === "rtl" ? d() : s();
        break;
      case "ArrowDown":
        k.preventDefault(), k.stopPropagation(), c();
        break;
      case "ArrowUp":
        k.preventDefault(), k.stopPropagation(), u();
        break;
      case "PageUp":
        k.preventDefault(), k.stopPropagation(), k.shiftKey ? b() : m();
        break;
      case "PageDown":
        k.preventDefault(), k.stopPropagation(), k.shiftKey ? v() : p();
        break;
      case "Home":
        k.preventDefault(), k.stopPropagation(), x();
        break;
      case "End":
        k.preventDefault(), k.stopPropagation(), y();
        break;
    }
    (w = n.onDayKeyDown) === null || w === void 0 || w.call(n, e, t, k);
  }, me = {
    onClick: C,
    onFocus: N,
    onBlur: M,
    onKeyDown: q,
    onKeyUp: he,
    onMouseEnter: I,
    onMouseLeave: T,
    onPointerEnter: R,
    onPointerLeave: A,
    onTouchCancel: B,
    onTouchEnd: L,
    onTouchMove: H,
    onTouchStart: fe
  };
  return me;
}
function rs() {
  var e = W(), t = ea(), n = Bt(), a = Yt(), r = it(e) ? t.selected : He(e) ? n.selected : Ve(e) ? a.selected : void 0;
  return r;
}
function os(e) {
  return Object.values(oe).includes(e);
}
function is(e, t) {
  var n = [e.classNames.day];
  return Object.keys(t).forEach(function(a) {
    var r = e.modifiersClassNames[a];
    if (r)
      n.push(r);
    else if (os(a)) {
      var o = e.classNames["day_".concat(a)];
      o && n.push(o);
    }
  }), n;
}
function ss(e, t) {
  var n = D({}, e.styles.day);
  return Object.keys(t).forEach(function(a) {
    var r;
    n = D(D({}, n), (r = e.modifiersStyles) === null || r === void 0 ? void 0 : r[a]);
  }), n;
}
function ta(e, t, n) {
  var a, r, o, i = W(), s = zt(), d = Zn(e, t), c = as(e, d), u = rs(), f = !!(i.onDayClick || i.mode !== "default");
  Q(function() {
    var I;
    d.outside || s.focusedDay && f && U(s.focusedDay, e) && ((I = n.current) === null || I === void 0 || I.focus());
  }, [
    s.focusedDay,
    e,
    n,
    f,
    d.outside
  ]);
  var h = is(i, d).join(" "), m = ss(i, d), p = !!(d.outside && !i.showOutsideDays || d.hidden), b = (o = (r = i.components) === null || r === void 0 ? void 0 : r.DayContent) !== null && o !== void 0 ? o : Pi, v = l(b, { date: e, displayMonth: t, activeModifiers: d }), x = {
    style: m,
    className: h,
    children: v,
    role: "gridcell"
  }, y = s.focusTarget && U(s.focusTarget, e) && !d.outside, C = s.focusedDay && U(s.focusedDay, e), N = D(D(D({}, x), (a = { disabled: d.disabled, role: "gridcell" }, a["aria-selected"] = d.selected, a.tabIndex = C || y ? 0 : -1, a)), c), M = {
    isButton: f,
    isHidden: p,
    activeModifiers: d,
    selectedDays: u,
    buttonProps: N,
    divProps: x
  };
  return M;
}
function ls(e) {
  var t = xe(null), n = ta(e.date, e.displayMonth, t);
  return n.isHidden ? l("div", { role: "gridcell" }) : n.isButton ? l(Ze, D({ name: "day", ref: t }, n.buttonProps)) : l("div", D({}, n.divProps));
}
function cs(e) {
  var t = e.number, n = e.dates, a = W(), r = a.onWeekNumberClick, o = a.styles, i = a.classNames, s = a.locale, d = a.labels.labelWeekNumber, c = a.formatters.formatWeekNumber, u = c(Number(t), { locale: s });
  if (!r)
    return l("span", { className: i.weeknumber, style: o.weeknumber, children: u });
  var f = d(Number(t), { locale: s }), h = function(m) {
    r(t, n, m);
  };
  return l(Ze, { name: "week-number", "aria-label": f, className: i.weeknumber, style: o.weeknumber, onClick: h, children: u });
}
function ds(e) {
  var t, n, a = W(), r = a.styles, o = a.classNames, i = a.showWeekNumber, s = a.components, d = (t = s == null ? void 0 : s.Day) !== null && t !== void 0 ? t : ls, c = (n = s == null ? void 0 : s.WeekNumber) !== null && n !== void 0 ? n : cs, u;
  return i && (u = l("td", { className: o.cell, style: r.cell, children: l(c, { number: e.weekNumber, dates: e.dates }) })), S("tr", { className: o.row, style: r.row, children: [u, e.dates.map(function(f) {
    return l("td", { className: o.cell, style: r.cell, role: "presentation", children: l(d, { displayMonth: e.displayMonth, date: f }) }, Ao(f));
  })] });
}
function pn(e, t, n) {
  for (var a = n != null && n.ISOWeek ? Bn(t) : Tt(t, n), r = n != null && n.ISOWeek ? Se(e) : ue(e, n), o = ce(a, r), i = [], s = 0; s <= o; s++)
    i.push(j(r, s));
  var d = i.reduce(function(c, u) {
    var f = n != null && n.ISOWeek ? Yn(u) : zn(u, n), h = c.find(function(m) {
      return m.weekNumber === f;
    });
    return h ? (h.dates.push(u), c) : (c.push({
      weekNumber: f,
      dates: [u]
    }), c);
  }, []);
  return d;
}
function us(e, t) {
  var n = pn(G(e), Rt(e), t);
  if (t != null && t.useFixedWeeks) {
    var a = Vo(e, t);
    if (a < 6) {
      var r = n[n.length - 1], o = r.dates[r.dates.length - 1], i = xt(o, 6 - a), s = pn(xt(o, 1), i, t);
      n.push.apply(n, s);
    }
  }
  return n;
}
function fs(e) {
  var t, n, a, r = W(), o = r.locale, i = r.classNames, s = r.styles, d = r.hideHead, c = r.fixedWeeks, u = r.components, f = r.weekStartsOn, h = r.firstWeekContainsDate, m = r.ISOWeek, p = us(e.displayMonth, {
    useFixedWeeks: !!c,
    ISOWeek: m,
    locale: o,
    weekStartsOn: f,
    firstWeekContainsDate: h
  }), b = (t = u == null ? void 0 : u.Head) !== null && t !== void 0 ? t : _i, v = (n = u == null ? void 0 : u.Row) !== null && n !== void 0 ? n : ds, x = (a = u == null ? void 0 : u.Footer) !== null && a !== void 0 ? a : Si;
  return S("table", { id: e.id, className: i.table, style: s.table, role: "grid", "aria-labelledby": e["aria-labelledby"], children: [!d && l(b, {}), l("tbody", { className: i.tbody, style: s.tbody, children: p.map(function(y) {
    return l(v, { displayMonth: e.displayMonth, dates: y.dates, weekNumber: y.weekNumber }, y.weekNumber);
  }) }), l(x, { displayMonth: e.displayMonth })] });
}
function hs() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var ms = hs() ? Na : Q, bt = !1, ps = 0;
function gn() {
  return "react-day-picker-".concat(++ps);
}
function gs(e) {
  var t, n = e ?? (bt ? gn() : null), a = E(n), r = a[0], o = a[1];
  return ms(function() {
    r === null && o(gn());
  }, []), Q(function() {
    bt === !1 && (bt = !0);
  }, []), (t = e ?? r) !== null && t !== void 0 ? t : void 0;
}
function vs(e) {
  var t, n, a = W(), r = a.dir, o = a.classNames, i = a.styles, s = a.components, d = We().displayMonths, c = gs(a.id ? "".concat(a.id, "-").concat(e.displayIndex) : void 0), u = a.id ? "".concat(a.id, "-grid-").concat(e.displayIndex) : void 0, f = [o.month], h = i.month, m = e.displayIndex === 0, p = e.displayIndex === d.length - 1, b = !m && !p;
  r === "rtl" && (t = [m, p], p = t[0], m = t[1]), m && (f.push(o.caption_start), h = D(D({}, h), i.caption_start)), p && (f.push(o.caption_end), h = D(D({}, h), i.caption_end)), b && (f.push(o.caption_between), h = D(D({}, h), i.caption_between));
  var v = (n = s == null ? void 0 : s.Caption) !== null && n !== void 0 ? n : Mi;
  return S("div", { className: f.join(" "), style: h, children: [l(v, { id: c, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), l(fs, { id: u, "aria-labelledby": c, displayMonth: e.displayMonth })] }, e.displayIndex);
}
function bs(e) {
  var t = W(), n = t.classNames, a = t.styles;
  return l("div", { className: n.months, style: a.months, children: e.children });
}
function ys(e) {
  var t, n, a = e.initialProps, r = W(), o = zt(), i = We(), s = E(!1), d = s[0], c = s[1];
  Q(function() {
    r.initialFocus && o.focusTarget && (d || (o.focus(o.focusTarget), c(!0)));
  }, [
    r.initialFocus,
    d,
    o.focus,
    o.focusTarget,
    o
  ]);
  var u = [r.classNames.root, r.className];
  r.numberOfMonths > 1 && u.push(r.classNames.multiple_months), r.showWeekNumber && u.push(r.classNames.with_weeknumber);
  var f = D(D({}, r.styles.root), r.style), h = Object.keys(a).filter(function(p) {
    return p.startsWith("data-");
  }).reduce(function(p, b) {
    var v;
    return D(D({}, p), (v = {}, v[b] = a[b], v));
  }, {}), m = (n = (t = a.components) === null || t === void 0 ? void 0 : t.Months) !== null && n !== void 0 ? n : bs;
  return l("div", D({ className: u.join(" "), style: f, dir: r.dir, id: r.id, nonce: a.nonce, title: a.title, lang: a.lang }, h, { children: l(m, { children: i.displayMonths.map(function(p, b) {
    return l(vs, { displayIndex: b, displayMonth: p }, b);
  }) }) }));
}
function xs(e) {
  var t = e.children, n = qo(e, ["children"]);
  return l(ui, { initialProps: n, children: l(wi, { children: l(ts, { initialProps: n, children: l(Fi, { initialProps: n, children: l(Ti, { initialProps: n, children: l(Ai, { children: l(es, { children: t }) }) }) }) }) }) });
}
function ws(e) {
  return l(xs, D({}, e, { children: l(ys, { initialProps: e }) }));
}
const vn = (e) => {
  const { selectedEl: t, options: n, value: a, callback: r, customStyles: o = {} } = e, i = xe(), [s, d] = E(!1);
  return /* @__PURE__ */ S("div", { "data-test-id": e["data-test-id"], children: [
    /* @__PURE__ */ S(
      "div",
      {
        className: "flex flex-row cursor-pointer",
        ref: i,
        onClick: () => {
          d((c) => !c);
        },
        children: [
          t(a),
          /* @__PURE__ */ l("div", { className: " rounded-r-[4px] h-[20px] px-[1px]", children: s ? /* @__PURE__ */ l(J.ChevronUp, { width: 20, height: 20 }) : /* @__PURE__ */ l(J.ChevronDown, { width: 20, height: 20 }) })
        ]
      }
    ),
    s && /* @__PURE__ */ l(
      js,
      {
        className: X(
          "h-[200px] rounded p-1 border border-solid border-color-divider mt-2 scrollbar-none shadow-[0_0_10px_5px_rgba(0,0,0,0.1)]",
          o.popover
        ),
        anchorEl: i.current,
        open: !0,
        onClose: () => {
          d(!1);
        },
        anchorVertical: "bottom",
        anchorHorizontal: "left",
        transformVertical: "top",
        transformHorizontal: "left",
        children: n.map((c) => /* @__PURE__ */ l(
          "div",
          {
            className: X(
              "flex flex-col py-2 px-3 cursor-pointer hover:bg-[#EFF1FF]"
            ),
            onClick: () => r(c),
            ref: (u) => {
              u && a.label === c.label && u.scrollIntoView();
            },
            children: /* @__PURE__ */ l(
              ae,
              {
                variant: "body1",
                themeColor: a.label === c.label ? "primary.main" : void 0,
                fb: a.label === c.label ? !0 : void 0,
                children: c.label
              }
            )
          }
        ))
      }
    )
  ] });
}, Cs = Te((e) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  cta: {
    cursor: "pointer",
    "& path": {
      fill: e.palette.primary.main
    }
  }
})), ks = (e) => {
  const {
    setMonth: t,
    fromYear: n,
    toYear: a,
    displayMonth: r,
    captionLabel: o,
    numberOfMonths: i = 1,
    displayIndex: s = 0
  } = e, d = on.map((C) => C.long), { nextMonth: c, previousMonth: u } = We(), f = d[r.getMonth()], h = r.getFullYear(), m = (C, N) => {
    t(new Date(C, N));
  }, p = on.map((C) => ({ label: C.long })), b = a.getFullYear(), v = n.getFullYear(), x = Array.from({ length: b - v + 1 }, (C, N) => ({
    label: String(v + N)
  })), y = Cs();
  return /* @__PURE__ */ S("div", { className: "w-[280px]", children: [
    /* @__PURE__ */ S("div", { className: "flex space-between flex-row items-center pb-3", children: [
      /* @__PURE__ */ l(
        J.ChevronLeft,
        {
          className: X(
            y.cta,
            "p-[7px] rounded-[4px] border-solid border-[1px] border-divider !w-10 !h-10",
            i > 1 && s > 0 ? "hidden" : ""
          ),
          onClick: () => {
            u && t(u);
          },
          "data-test-id": "previous-month"
        }
      ),
      /* @__PURE__ */ S("div", { className: "flex flex-1 justify-center p-1 gap-2", children: [
        /* @__PURE__ */ l(
          vn,
          {
            selectedEl: (C) => /* @__PURE__ */ l(ae, { variant: "subHeadingMedium", children: C.label }),
            options: p,
            value: { label: f },
            callback: (C) => {
              m(h, d.indexOf(C.label));
            },
            "data-test-id": "month-selector"
          }
        ),
        /* @__PURE__ */ l(
          vn,
          {
            selectedEl: (C) => /* @__PURE__ */ l(ae, { variant: "subHeadingMedium", children: C.label }),
            options: x,
            value: { label: h.toString() },
            callback: (C) => {
              m(parseInt(C.label), d.indexOf(f));
            },
            "data-test-id": "year-selector"
          }
        )
      ] }),
      /* @__PURE__ */ l(
        J.ChevronRight,
        {
          className: X(
            y.cta,
            "p-[7px] rounded-[4px] border-solid border-[1px] border-divider !w-10 !h-10",
            i > 1 && s < i - 1 ? "hidden" : ""
          ),
          onClick: () => c && t(c),
          "data-test-id": "next-month"
        }
      )
    ] }),
    o && /* @__PURE__ */ l(ae, { variant: "subtitle1", className: "pb-3", children: o })
  ] });
}, De = {
  day: {
    backgroundColor: "transparent",
    borderTopRightRadius: "0px",
    borderBottomRightRadius: "0px",
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
    color: "#404040",
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "16px",
    letterSpacing: "0.02em",
    display: "flex",
    flexDirection: "column"
  },
  today: {
    border: "1px solid #73767C",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    letterSpacing: "0.02em",
    borderTopRightRadius: "50%",
    borderBottomRightRadius: "50%",
    borderTopLeftRadius: "50%",
    borderBottomLeftRadius: "50%"
  },
  selected: {
    color: "white",
    backgroundColor: "#3543BF",
    borderTopRightRadius: "50%",
    borderBottomRightRadius: "50%",
    borderTopLeftRadius: "50%",
    borderBottomLeftRadius: "50%"
  },
  todaySelected: {
    border: "1px solid white",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    letterSpacing: "0.02em",
    borderTopRightRadius: "50%",
    borderBottomRightRadius: "50%",
    borderTopLeftRadius: "50%",
    borderBottomLeftRadius: "50%",
    color: "white",
    backgroundColor: "#3543BF"
  },
  rangeMiddle: {
    backgroundColor: "#EFF1FF"
  },
  weekStart: {
    borderTopLeftRadius: "50%",
    borderBottomLeftRadius: "50%",
    borderTopRightRadius: "0px",
    borderBottomRightRadius: "0px"
  },
  weekEnd: {
    borderTopRightRadius: "50%",
    borderBottomRightRadius: "50%",
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px"
  }
}, yt = {
  rangeStart: {
    backgroundClip: "content-box",
    borderTopLeftRadius: "100%",
    borderBottomLeftRadius: "100%",
    backgroundColor: "#EFF1FF"
  },
  rangeEnd: {
    backgroundClip: "content-box",
    borderTopRightRadius: "100%",
    borderBottomRightRadius: "100%",
    backgroundColor: "#EFF1FF"
  },
  rangeMiddle: {
    backgroundClip: "content-box",
    borderRadius: "0%",
    backgroundColor: "#EFF1FF"
  }
};
function Ds(e) {
  const t = xe(null), n = ta(e.date, e.displayMonth, t), a = Zn(e.date), r = {
    ...n.buttonProps.style ?? {},
    ...De.day,
    ...a.rangeMiddle ? De.rangeMiddle : {},
    ...a.weekStart && a.rangeMiddle ? De.weekStart : {},
    ...a.weekEnd && a.rangeMiddle ? De.weekEnd : {},
    ...a.today ? De.today : {},
    ...a.selected || a.rangeStart || a.rangeEnd ? De.selected : {},
    ...a.today && (a.rangeStart || a.rangeEnd || a.selected) ? De.todaySelected : {}
  }, o = {
    ...a.rangeMiddle && a.today ? yt.rangeMiddle : {},
    ...a.rangeStart || a.weekStart && a.rangeMiddle ? yt.rangeStart : {},
    ...a.rangeEnd || a.weekEnd && a.rangeMiddle ? yt.rangeEnd : {}
  };
  return n.isHidden ? /* @__PURE__ */ l("div", { role: "gridcell" }) : n.isButton ? /* @__PURE__ */ l(
    "div",
    {
      className: !a.disabled && !a.outside && "hover:bg-[#EFF1FF] hover:rounded-full",
      "data-test-id": a.disabled ? "disabled-day" : "active-day",
      children: /* @__PURE__ */ l("div", { style: o, children: /* @__PURE__ */ S(
        "button",
        {
          ...n.buttonProps,
          style: r,
          className: X(n.buttonProps.className, "relative"),
          children: [
            a.blocked && /* @__PURE__ */ l(
              "div",
              {
                className: "absolute bg-[#73767C] left-[18px] bottom-0 top-2 h-[22px] w-[1px]",
                style: {
                  transform: "rotate(45deg)"
                }
              }
            ),
            e.date.getDate(),
            a.today && /* @__PURE__ */ l(
              "div",
              {
                className: X(
                  a.selected || a.rangeStart || a.rangeEnd ? "bg-[#fff]" : "bg-[#222EA7]",
                  "w-1 h-1 rounded"
                )
              }
            )
          ]
        }
      ) })
    }
  ) : /* @__PURE__ */ l("div", { ...n.divProps });
}
const Ms = /* @__PURE__ */ new Date("2000-01-01"), Ss = /* @__PURE__ */ new Date("2099-12-31"), na = (e) => {
  const {
    handleDayClick: t = () => {
    },
    initialMonth: n = /* @__PURE__ */ new Date(),
    modifiers: a,
    disabled: r = [],
    numberOfMonths: o = 1,
    month: i,
    setMonth: s,
    modifiersStyles: d,
    fromYear: c = Ms,
    toYear: u = Ss,
    selected: f,
    renderDay: h = Ds,
    renderCaption: m = ks,
    className: p = "",
    captionLabel: b,
    disableNavigation: v = !1,
    styles: x = {
      root: {
        margin: "0px"
      },
      caption_start: {
        borderRight: "1px solid #E0E0E0"
      },
      month: {
        margin: "0px",
        padding: "20px 24px",
        gap: "12px"
      },
      cell: {
        paddingTop: "4px",
        border: "none"
      },
      head_cell: {
        border: "none",
        textTransform: "none",
        fontWeight: "500",
        fontSize: "14px",
        lineHeight: "20px"
      }
    },
    ...y
  } = e, C = {};
  return m && (C.Caption = (N) => /* @__PURE__ */ l(
    m,
    {
      month: i,
      setMonth: s,
      fromYear: c,
      toYear: u,
      captionLabel: b,
      numberOfMonths: o,
      ...N
    }
  )), h && (C.Day = (N) => /* @__PURE__ */ l(h, { ...N })), /* @__PURE__ */ l(
    ws,
    {
      "data-test-id": e["data-test-id"],
      fromYear: c.getFullYear(),
      toYear: u.getFullYear(),
      numberOfMonths: o,
      mode: "default",
      onDayClick: t,
      disableNavigation: v,
      month: i,
      defaultMonth: n,
      disabled: r,
      selected: f,
      onMonthChange: s,
      weekStartsOn: 1,
      modifiers: {
        weekStart: { dayOfWeek: [1] },
        weekEnd: { dayOfWeek: [0] },
        ...a
      },
      today: /* @__PURE__ */ new Date(),
      components: C,
      className: `${p} select-none`,
      classNames: {},
      styles: x,
      modifiersClassNames: {
        day: "day",
        weekStart: "week_start relative",
        weekEnd: "week_end relative",
        disabled: "disabled",
        blocked: "blocked",
        rangeStart: "range_start",
        rangeEnd: "range_end",
        rangeMiddle: "range_middle"
      },
      modifiersStyles: d,
      ...y
    }
  );
}, Ns = () => {
  const e = /* @__PURE__ */ new Date();
  return {
    clear: {
      label: "Clear",
      get: () => null
    },
    today: {
      label: "Today",
      get: () => e
    }
  };
}, Os = () => {
  const e = /* @__PURE__ */ new Date();
  return {
    clear: {
      label: "Clear",
      get: () => []
    },
    today: {
      label: "Today",
      get: () => [e]
    }
  };
}, aa = () => {
  const e = /* @__PURE__ */ new Date(), t = e.getDay(), n = e.getFullYear(), a = e.getMonth(), r = e.getDate();
  return {
    clear: {
      label: "Clear",
      get: () => ({ from: null, to: null })
    },
    today: {
      label: "Today",
      get: () => ({ from: e, to: e })
    },
    yesterday: {
      label: "Yesterday",
      get: () => {
        const o = /* @__PURE__ */ new Date();
        return o.setDate(o.getDate() - 1), { from: o, to: o };
      }
    },
    "next-7-days": {
      label: "This Week",
      get: (o = e) => {
        const i = sn(6, "d", o);
        return { from: o, to: i };
      }
    },
    "prev-7-days": {
      label: "This Week",
      get: (o = e) => {
        const i = sn(6, "d", o);
        return { from: o, to: i };
      }
    },
    "this-week": {
      label: "This Week",
      get: () => {
        const o = new Date(
          n,
          a,
          r - t
        ), i = new Date(
          n,
          a,
          r + (6 - t)
        );
        return { from: o, to: i };
      }
    },
    "last-week": {
      label: "Last Week",
      get: () => {
        const o = new Date(
          n,
          a,
          r - t - 7
        ), i = new Date(
          n,
          a,
          r - t - 1
        );
        return { from: o, to: i };
      }
    },
    "this-month": {
      label: "This Month",
      get: () => {
        const o = new Date(n, a, 1), i = new Date(n, a + 1, 0);
        return { from: o, to: i };
      }
    },
    "last-month": {
      label: "Last Month",
      get: () => {
        const o = a - 1, i = new Date(n, o, 1), s = new Date(n, o + 1, 0);
        return { from: i, to: s };
      }
    },
    "this-year": {
      label: "This Year",
      get: () => {
        const o = new Date(n, 0, 1), i = new Date(n, 11, 31);
        return { from: o, to: i };
      }
    },
    "last-year": {
      label: "Last Year",
      get: () => {
        const o = n - 1, i = new Date(o, 0, 1), s = new Date(o, 11, 31);
        return { from: i, to: s };
      }
    },
    "all-time": {
      label: "All Time",
      get: () => {
        const o = new Date(2e3, 0, 1), i = new Date(2099, 11, 31);
        return { from: o, to: i };
      }
    }
  };
}, _s = (e) => {
  const {
    calendarProps: t,
    optionsToShow: n = [
      "today",
      "yesterday",
      "this-week",
      "last-week",
      "this-month",
      "last-month",
      "this-year",
      "last-year",
      "all-time"
    ],
    invalidDates: [a, ...r],
    selectAndNavigateDate: o
  } = e, { selectedDays: i } = t, s = wn(() => {
    const d = aa();
    return n.map((c) => {
      const u = d[c].get(), { from: f, to: h } = u, m = f > a.after || f < a.before || r.includes(f), p = h ? h > a.after || h < a.before || r.includes(h) : !1, b = i.from && i.to && f && h ? Ye(i.from, f) && Ye(i.to, h) : !1;
      return {
        label: d[c].label,
        range: u,
        key: c,
        disabled: m || p,
        active: b
      };
    });
  }, [n, i]);
  return /* @__PURE__ */ l("div", { className: " px-4 py-3 border-solid border-[1px] border-y-0 border-l-0 border-color-divider", children: s.map((d) => /* @__PURE__ */ l(
    "div",
    {
      className: X(
        "rounded-md pl-4 pr-7 py-3 cursor-pointer hover:bg-color-primaryLighter",
        d.disabled && "bg-color-light pointer-events-none",
        d.active && "bg-color-primaryLighter"
      ),
      onClick: () => {
        d.disabled || o({
          selectedDays: d.range,
          calendarProps: t
        });
      },
      children: /* @__PURE__ */ l(
        ae,
        {
          variant: "subtitle1",
          themeColor: d.active ? "primary.main" : "common.black",
          fb: !0,
          children: d.label
        }
      )
    },
    d.key
  )) });
}, Ps = (e) => {
  const {
    primaryCta: t,
    secondaryCta: n,
    hideCalendar: a,
    calendarProps: r,
    selectAndNavigateDate: o
  } = e, { variant: i } = r, s = {
    ...i === "single" ? Ns() : i === "multiple" ? Os() : aa(),
    apply: { label: "Apply", onClick: a }
  }, d = (c) => {
    if (c === "apply")
      s[c].onClick();
    else {
      const u = s[c].get();
      o({
        selectedDays: u,
        calendarProps: r
      });
    }
  };
  return /* @__PURE__ */ l("div", { className: "border-solid border-[1px] border-x-0 border-b-0 border-color-divider p-4", children: /* @__PURE__ */ S("div", { className: "flex gap-3 justify-end", children: [
    t && /* @__PURE__ */ l(
      Je,
      {
        onClick: () => d(t),
        variant: "text",
        className: n ? "flex-1" : "w-[120px]",
        disabled: i === "single" && t === "today" ? Ye(r.selectedDays, /* @__PURE__ */ new Date()) : !1,
        children: s[t].label
      }
    ),
    n && /* @__PURE__ */ l(
      Je,
      {
        onClick: () => d(n),
        className: t ? "flex-1" : "w-[120px]",
        disabled: i === "single" && n === "today" ? Ye(r.selectedDays, /* @__PURE__ */ new Date()) : !1,
        children: s[n].label
      }
    )
  ] }) });
}, bn = ({ selectedDays: e, calendarProps: t }) => {
  const { variant: n, setSelectedDays: a, setMonth: r } = t;
  n === "single" ? (a(e), r(e ?? /* @__PURE__ */ new Date())) : n === "multiple" ? (a(e), r(e[0] ?? /* @__PURE__ */ new Date())) : n === "range" && (t.setRange(e), r(e.from ?? /* @__PURE__ */ new Date()));
}, ra = (e) => {
  const t = /* @__PURE__ */ new Date(), {
    modifiers: n = {},
    blockedDates: a = [],
    anchorEl: r,
    calendarProps: o,
    popoverState: i,
    numberOfMonths: s = 1,
    showDatePickerMenu: d = !1,
    primaryCta: c,
    secondaryCta: u,
    fromYear: f,
    toYear: h,
    skipHideOnSelect: m = !1,
    className: p = "",
    captionLabel: b,
    disabledBefore: v = t
  } = e, { variant: x, initialMonth: y, month: C, setMonth: N } = o, { isCalendarOpen: M, hideCalendar: I } = i, T = {};
  if (x === "range") {
    const { selectedDays: B } = o, { from: L, to: H } = B;
    T.modifiers = {
      ...n,
      blocked: a,
      rangeStart: L,
      rangeEnd: H,
      rangeMiddle: L && H && !Ye(L, H) ? {
        before: H,
        after: L
      } : []
    }, T.disabled = [
      e.disabledBefore && { before: e.disabledBefore },
      e.disabledAfter && { after: e.disabledAfter },
      ...a
    ];
  } else
    T.modifiers = {
      blocked: a
    }, T.selected = o.selectedDays, T.disabled = [
      {
        after: e.disabledAfter,
        before: v
      },
      ...a
    ];
  const R = () => {
    I(), x === "range" && (o.setIsFirstClickInFromInput(!0), o.setIsFirstClickInToInput(!0));
  };
  Q(() => {
    var B;
    N(
      x === "range" ? (B = o.selectedDays) != null && B.from && (!e.disabledBefore || le(
        o.selectedDays.from,
        e.disabledBefore
      ) >= 0) && (!e.disabledAfter || le(
        o.selectedDays.from,
        e.disabledAfter
      ) <= 0) ? o.selectedDays.from : t : y
    );
  }, [M]), Q(() => {
    const B = x === "single" && o.selectedDays || x === "multiple" && o.selectedDays.length > 0 || x === "range" && o.selectedDays.from && o.selectedDays.to;
    !m && B && R();
  }, [o.selectedDays]);
  const A = () => x === "range" ? o.inputBoxSelected === "TO" ? o.handleToDayClick : o.handleFromDayClick : o.handleDayClick;
  return /* @__PURE__ */ l(
    Sn,
    {
      open: M,
      anchorEl: r.current,
      onClose: R,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      },
      transitionDuration: "auto",
      classes: {
        paper: "rounded-xl border-solid border-[1px] border-divider"
      },
      children: /* @__PURE__ */ S("div", { className: "flex", children: [
        d && x === "range" && /* @__PURE__ */ l(
          _s,
          {
            calendarProps: o,
            optionsToShow: e.datePickerMenuOptions,
            invalidDates: T.disabled,
            selectAndNavigateDate: bn
          }
        ),
        /* @__PURE__ */ S("div", { className: "flex flex-col", children: [
          /* @__PURE__ */ l(
            na,
            {
              className: p,
              handleDayClick: A(),
              initialMonth: y,
              modifiers: n,
              numberOfMonths: s,
              month: C,
              setMonth: N,
              fromYear: f,
              toYear: h,
              captionLabel: b,
              "data-test-id": e["data-test-id"],
              ...T
            }
          ),
          (c || u) && /* @__PURE__ */ l(
            Ps,
            {
              primaryCta: c,
              secondaryCta: u,
              hideCalendar: I,
              calendarProps: o,
              selectAndNavigateDate: bn,
              isMultiCalendar: s > 1
            }
          )
        ] })
      ] })
    }
  );
}, Fs = ({ calendarInputProps: e, anchorEl: t }) => {
  const {
    calendarProps: n,
    popoverState: a,
    disabled: r = !1,
    error: o = !1,
    leftElement: i,
    rightElement: s = /* @__PURE__ */ l("img", { src: J.CalendarIcon, alt: "calendar-icon" }),
    placeholder: d,
    inputDateFormat: c = "DD MMM YYYY, ddd",
    inputClasses: u = ""
  } = e, { showCalendar: f } = a, h = wn(() => {
    const { variant: p, selectedDays: b } = n;
    switch (p) {
      case "single":
        return b ? ge(b, c) : "";
      case "multiple":
        return b.length > 0 ? `${b.length} day${b.length > 1 ? "s" : ""} selected` : "";
      case "range": {
        const { from: v, to: x } = b;
        return `${v ? `${ge(v, c)} - ` : ""}${x ? ge(x, c) : ""}`;
      }
    }
  }, [n.selectedDays]), m = n.variant === "single" ? "Enter Date" : n.variant === "multiple" ? "Select Dates" : "Select a range";
  return /* @__PURE__ */ l(
    Ct,
    {
      className: X(
        u,
        "[&>input]:cursor-pointer cursor-pointer"
      ),
      onClick: (p) => f(),
      value: h,
      ref: t,
      disabled: r,
      error: o,
      leftElement: i,
      rightElement: s,
      placeholder: d ?? m,
      readOnly: !0
    }
  );
}, Is = ({ calendarInputProps: e, anchorEl: t }) => {
  const {
    calendarProps: n,
    popoverState: a,
    disabled: r = !1,
    error: o = !1,
    rightElement: i = /* @__PURE__ */ l("img", { src: J.CalendarIcon, alt: "calendar-icon" }),
    inputDateFormat: s = "DD MMM YYYY, ddd",
    startDateText: d = "Start Date",
    endDateText: c = "End Date",
    hasNoEndDate: u = !1,
    inputClasses: f = ""
  } = e, { showCalendar: h } = a, {
    selectedDays: { from: m, to: p },
    setInputBoxSelected: b
  } = n, v = xe(), x = xe(), y = (M, I) => {
    b(I), h();
  }, C = m ? ge(m, s) : "", N = p ? ge(p, s) : "";
  return /* @__PURE__ */ S("div", { className: "flex gap-2 w-full", ref: t, children: [
    /* @__PURE__ */ S("div", { className: "flex flex-col gap-1 flex-1", children: [
      /* @__PURE__ */ l(ae, { variant: "body1", fb: !0, children: d }),
      /* @__PURE__ */ l(
        Ct,
        {
          className: X(
            f,
            "[&>input]:cursor-pointer cursor-pointer"
          ),
          onClick: (M) => y(v, "FROM"),
          value: C,
          disabled: r,
          error: o,
          rightElement: i,
          placeholder: "Start Date",
          readOnly: !0
        }
      )
    ] }),
    !u && /* @__PURE__ */ S("div", { className: "flex flex-col gap-1 flex-1", children: [
      /* @__PURE__ */ l(ae, { variant: "body1", fb: !0, children: c }),
      /* @__PURE__ */ l(
        Ct,
        {
          className: X(
            f,
            "[&>input]:cursor-pointer cursor-pointer"
          ),
          onClick: (M) => y(x, "TO"),
          value: N,
          disabled: r,
          error: o,
          rightElement: i,
          placeholder: "End Date",
          readOnly: !0
        }
      )
    ] })
  ] });
}, oa = (e) => {
  const {
    calendarProps: t,
    popoverState: n,
    hasTwoInputs: a = !1,
    customInput: r = a && t.variant === "range" ? Is : Fs,
    ...o
  } = e, i = xe(null);
  return /* @__PURE__ */ S(ee, { children: [
    /* @__PURE__ */ l(r, { calendarInputProps: e, anchorEl: i }),
    /* @__PURE__ */ l(
      ra,
      {
        calendarProps: t,
        popoverState: n,
        anchorEl: i,
        numberOfMonths: a ? 2 : 1,
        ...o
      }
    )
  ] });
}, Rs = (e) => {
  const {
    groupedDates: t,
    handleRemoveDates: n,
    dateFormat: a = "MMM DD YYYY, ddd",
    maxChips: r = 5
  } = e, [o, i] = E(!1), s = (d) => {
    const c = ge(d[0], a), u = ge(d[d.length - 1], a);
    return d.length === 1 ? c : `${c} - ${u}`;
  };
  return Q(() => {
    o && t.length <= r && i(!1);
  }, [t, o, r]), /* @__PURE__ */ S("div", { className: "flex flex-wrap gap-1 pt-1", children: [
    (o ? t : t.slice(0, r)).map(
      (d, c) => /* @__PURE__ */ l(
        Vs,
        {
          label: s(d),
          onDelete: () => n(c, t)
        }
      )
    ),
    o ? /* @__PURE__ */ l(Je, { variant: "text", onClick: () => i(!1), children: "Show Less" }) : t.length > r ? /* @__PURE__ */ l(Je, { variant: "text", onClick: () => i(!0), children: `+ ${t.length - r} More` }) : null
  ] });
}, Ts = (e) => {
  if (e.calendarProps.variant !== "multiple")
    throw new Error("BlackoutCalendarInput only supports multiple variant");
  const {
    calendarProps: { selectedDays: t, handleRemoveMultipleDates: n }
  } = e, a = Fr(t, !1), { skipHideOnSelect: r = !0, secondaryCta: o = "apply", ...i } = e;
  return /* @__PURE__ */ S("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ l(
      oa,
      {
        skipHideOnSelect: r,
        secondaryCta: o,
        ...i
      }
    ),
    /* @__PURE__ */ l(
      Rs,
      {
        groupedDates: a,
        handleRemoveDates: n
      }
    )
  ] });
}, Ws = (e) => {
  switch (e.type) {
    case "default":
      return /* @__PURE__ */ l(na, { ...e });
    case "basic":
      return /* @__PURE__ */ l(ra, { ...e });
    case "input":
      return /* @__PURE__ */ l(oa, { ...e });
    case "blackout":
      return /* @__PURE__ */ l(Ts, { ...e });
  }
};
function Tl(e) {
  const t = xe(), {
    label: n,
    style: a,
    popoverState: r,
    calendarProps: o,
    disabledBefore: i,
    disabledAfter: s,
    onOptionChange: d,
    selectedValue: c,
    options: u,
    noBorder: f = !1,
    className: h = "",
    isInline: m = !1
  } = e, p = { width: "200px", ...a }, { isCalendarOpen: b } = r;
  return Q(() => {
    b || Dt(c == null ? void 0 : c.from) && d(u[0]);
  }, [b]), Q(() => {
    t.current && t.current.focus();
  }, [c]), /* @__PURE__ */ S("div", { className: "CustomDateDropdown", children: [
    n && /* @__PURE__ */ l("div", { className: "Label", children: n }),
    /* @__PURE__ */ l("div", { children: /* @__PURE__ */ l(
      vl,
      {
        ref: t,
        onChange: d,
        value: c,
        placeholder: "Please select a time period",
        options: u,
        style: p,
        disableClear: !0,
        labelField: "label",
        renderOption: (x, y) => {
          const C = y.value === "Custom" ? () => d(y) : null;
          return /* @__PURE__ */ l("div", { ...x, onClick: C, children: y.label });
        },
        noBorder: f,
        className: h,
        isInline: m
      }
    ) }),
    /* @__PURE__ */ l(
      Ws,
      {
        type: "basic",
        calendarProps: o,
        popoverState: r,
        anchorEl: t,
        disabledAfter: s,
        disabledBefore: i
      }
    )
  ] });
}
const Wl = (e, t, n = {}) => {
  const [a, r] = E(e), o = (u, f) => `${ge(u)} - ${ge(f)}`, { calendarProps: i, popoverState: s } = Er({
    ...n,
    callbackAfterDateSelection: ({ from: u, to: f }) => {
      if (f) {
        const h = o(u, f);
        r({ label: h, value: "Custom", from: u, to: f });
      }
    }
  }), d = (u) => {
    u.value === "Custom" ? s.showCalendar() : (i.setRange({ from: null, to: null }), s.hideCalendar()), r(u);
  }, c = [...t];
  return a && (a == null ? void 0 : a.value) === "Custom" ? c.push(a) : c.push({ label: "Custom", value: "Custom" }), {
    selectedValue: a,
    onOptionChange: d,
    popoverState: s,
    options: c,
    calendarProps: i
  };
}, Es = Te((e) => ({
  root: {
    width: "100%",
    height: "40px",
    overflow: "hidden",
    borderRadius: "4px",
    fontFamily: "Roboto",
    boxSizing: "border-box",
    fontSize: "14px !important",
    backgroundColor: e.palette.common.white,
    "& input": {
      boxSizing: "border-box",
      height: "40px",
      paddingTop: "14px",
      paddingBottom: "14px"
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${e.palette.divider}`,
      top: "0px",
      boxSizing: "border-box",
      height: "40px",
      "& legend": {
        display: "none"
      }
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${e.palette.text.primary}`
    },
    "&.Mui-error .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${e.palette.error.main}`
    },
    "& input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button": {
      appearance: "none",
      margin: 0
    },
    "&.Mui-disabled": {
      backgroundColor: e.palette.backgrounds.dark,
      color: "#404040 !important"
    },
    "&.Mui-disabled ,&.Mui-disabled > input ": {
      color: "#404040 !important",
      cursor: "not-allowed"
    }
  },
  endCloseIcon: {
    marginRight: "12px",
    width: "20px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: e.palette.backgrounds.dark,
      borderRadius: "12px",
      padding: "3px",
      transition: "all 0.2s"
    }
  },
  small: {
    width: "182px"
  },
  prefixSuffix: {
    backgroundColor: "#EFEFEF",
    padding: "10px",
    color: "#787878",
    fontSize: "14px !important"
  },
  adornedStart: {
    paddingLeft: "0px"
  },
  adornedEnd: { paddingRight: "0px" },
  input: (t) => ({
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 1000px white inset"
    },
    textAlign: t.orientation
  })
})), Bs = (e, t) => {
  const {
    type: n = "text",
    readValueOnChange: a = (z) => z,
    placeholder: r = "",
    disabled: o = !1,
    value: i = "",
    onChange: s = (z) => z,
    onBlur: d,
    disableClear: c = !0,
    leftElement: u,
    rightElement: f,
    error: h = !1,
    format: m,
    onClick: p,
    readOnly: b = !1,
    style: v,
    orientation: x = "left",
    size: y = "medium",
    name: C = "",
    autoFocus: N = !1,
    min: M = 0,
    //For type number
    max: I,
    //For type number,
    charLimit: T,
    decimalPoints: R = 2,
    prefix: A = "",
    suffix: B = "",
    className: L = "",
    onFocusCapture: H,
    convertToUppercase: fe = !1,
    onKeyDown: he,
    autoComplete: q,
    elementClassNames: me = "",
    ...k
  } = e, w = Es({ orientation: x }), $ = (z) => {
    const { name: Ee } = z.target;
    if (n === "text" || n === "password") {
      let ve = z.target.value;
      fe && (ve = z.target.value.toUpperCase()), a(ve), s(ve, Ee);
    } else {
      const ve = Oa(z, R);
      s(ve, Ee), a(ve);
    }
  }, ie = (z) => {
    n === "number" && z.target instanceof HTMLElement && z.target.blur();
  }, se = (z) => {
    n === "number" && z.key === "-" && z.preventDefault();
  }, je = kt(k);
  return /* @__PURE__ */ l(
    Ba,
    {
      autoComplete: q,
      autoFocus: N,
      name: C,
      type: n,
      inputRef: t,
      className: X(
        w.root,
        y === "small" ? w.small : "",
        L
      ),
      onWheel: ie,
      placeholder: r,
      disabled: o,
      onChange: $,
      onBlur: d,
      onFocusCapture: H,
      onClick: p,
      value: m ? m(i) : i,
      endAdornment: f ? /* @__PURE__ */ S(Ge, { position: "end", children: [
        /* @__PURE__ */ l("div", { className: "pr-3", children: f }),
        B && /* @__PURE__ */ l("div", { className: w.prefixSuffix, children: B })
      ] }) : c ? B ? /* @__PURE__ */ l(Ge, { position: "end", children: B && /* @__PURE__ */ l("div", { className: w.prefixSuffix, children: B }) }) : null : /* @__PURE__ */ S(Ge, { position: "end", children: [
        /* @__PURE__ */ l(
          J.Close,
          {
            className: w.endCloseIcon,
            onClick: () => s ? s("", C) : null
          }
        ),
        B && /* @__PURE__ */ l("div", { className: w.prefixSuffix, children: B })
      ] }),
      startAdornment: (u || A) && /* @__PURE__ */ S(Ge, { position: "start", children: [
        A && /* @__PURE__ */ l("div", { className: w.prefixSuffix, children: A }),
        u && /* @__PURE__ */ l("div", { className: `${A ? "" : "pl-3"} ${me}`, children: u })
      ] }),
      inputProps: {
        min: M,
        max: I,
        maxLength: T,
        ...je,
        className: w.input,
        style: {
          textAlign: x
        }
      },
      error: h,
      readOnly: b,
      style: v,
      classes: {
        adornedStart: w.adornedStart,
        adornedEnd: w.adornedEnd
      },
      sx: {
        "& .MuiInputBase-input.Mui-disabled": {
          WebkitTextFillColor: "black"
        }
      },
      onKeyDown: he,
      onKeyPress: se
    }
  );
}, Ct = et(Bs);
var Ht = {}, Ls = Va;
Object.defineProperty(Ht, "__esModule", {
  value: !0
});
var ia = Ht.default = void 0, Ys = Ls(Ha()), $s = Sa, zs = (0, Ys.default)(/* @__PURE__ */ (0, $s.jsx)("path", {
  d: "M18.3 5.71a.9959.9959 0 0 0-1.41 0L12 10.59 7.11 5.7a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
}), "ClearRounded");
ia = Ht.default = zs;
const As = Te((e) => ({
  root: {
    borderRadius: "60px",
    height: "32px",
    padding: "4px 8px 4px 8px",
    gap: "4px",
    userSelect: "none",
    background: e.palette.backgrounds.white,
    border: `1px solid ${e.palette.backgrounds.divider}`,
    fontStyle: "normal",
    color: e.palette.common.black,
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    '& [class*="MuiChip-deleteIcon"]': {
      color: "inherit",
      width: "16px",
      height: "16px",
      cursor: "pointer",
      margin: "0px"
    },
    "&.Mui-disabled": {
      // background: theme.palette.backgrounds.light,
      // border: `1px solid ${theme.palette.backgrounds.divider}`,
      '& [class*="MuiChip-deleteIcon"]': {
        color: "inherit",
        width: "16px",
        height: "16px",
        cursor: "pointer",
        margin: "0px"
      }
    }
  },
  label: {
    padding: "0px"
  },
  sizeSmall: {
    height: "24px",
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0.02em"
  },
  active: {
    border: `1px solid ${e.palette.primary.main}`,
    background: e.palette.primary.lighter,
    '& [class*="MuiChip-deleteIcon"]': {
      color: e.palette.primary.main,
      width: "16px",
      height: "16px",
      cursor: "pointer"
    },
    "&:hover": {
      background: "rgba(0, 0, 0, 0.04) !important",
      '& [class*="MuiChip-deleteIcon"]': {
        color: e.palette.primary.main,
        width: "16px",
        height: "16px",
        cursor: "pointer"
      }
    }
  }
}));
function Hs(e, t, n, a) {
  switch (e) {
    case "checkbox":
      return /* @__PURE__ */ l(Ot, { checked: n, disabled: a, className: "p-0" });
    case "radio":
      return /* @__PURE__ */ l(Sr, { checked: n, disabled: a, className: "p-0" });
    default:
      return t;
  }
}
const Vs = (e) => {
  const {
    label: t,
    className: n = "",
    size: a = "medium",
    prefix: r,
    icon: o,
    disabled: i = !1,
    selected: s = !1,
    onDelete: d,
    onClick: c,
    badge: u,
    tag: f,
    ...h
  } = e, m = As();
  return /* @__PURE__ */ l(
    Cn,
    {
      classes: {
        root: X(m.root, n),
        label: m.label,
        sizeSmall: m.sizeSmall,
        colorSuccess: m.active
      },
      label: /* @__PURE__ */ S("div", { className: "flex items-center gap-1", children: [
        Hs(r, o, s, i),
        t,
        u,
        f
      ] }),
      deleteIcon: /* @__PURE__ */ l(ia, {}),
      onDelete: d,
      size: a,
      variant: "outlined",
      onClick: c,
      disabled: i,
      color: s ? "success" : "default",
      ...h
    }
  );
};
function js(e) {
  const {
    open: t,
    anchorEl: n,
    onClose: a,
    children: r,
    className: o = "",
    style: i,
    disableTransition: s = !1,
    anchorVertical: d = "bottom",
    anchorHorizontal: c = "center",
    transformVertical: u = "top",
    transformHorizontal: f = "center",
    keepMounted: h = !1
  } = e;
  return /* @__PURE__ */ l(
    Sn,
    {
      open: t,
      keepMounted: h,
      onClose: a,
      anchorEl: n,
      classes: { paper: o },
      style: i,
      anchorOrigin: {
        vertical: d,
        horizontal: c
      },
      transformOrigin: {
        vertical: u,
        horizontal: f
      },
      transitionDuration: s ? 0 : "auto",
      children: r
    }
  );
}
const qs = Te((e) => ({
  autocompleteRoot: {
    width: "100%"
  },
  notFaded: {
    "& .Mui-disabled": {
      color: `${e.palette.text.primary}`,
      // Keep the text color
      "-webkit-text-fill-color": `${e.palette.text.primary}`,
      // For some browsers
      opacity: 1
      // Prevent fading
    }
  },
  root: (t) => ({
    width: "100%",
    height: !t.isInline && t.isCheckboxVariant || t.isChipVariant ? "full" : t.isInlineBorder ? "auto" : "40px",
    borderRadius: "4px",
    fontFamily: "Roboto",
    backgroundColor: t.disabled ? `${e.palette.backgrounds.light}` : `${e.palette.common.white}`,
    "& > div:first-child": {
      minHeight: "40px !important",
      padding: t.isCheckboxVariant || t.isChipVariant ? "9px 34px 9px 8px !important" : "1px",
      backgroundColor: "inherit",
      gap: t.isCheckboxVariant || t.isChipVariant ? "4px" : "",
      "& input": {
        color: `${e.palette.text.primary} !important`,
        minWidth: (t.isCheckboxVariant || t.isChipVariant) && "0",
        height: (t.isCheckboxVariant || t.isChipVariant) && "0",
        "&:focus": {
          minWidth: (t.isCheckboxVariant || t.isChipVariant) && "100%",
          display: (t.isCheckboxVariant || t.isChipVariant) && "block",
          height: (t.isCheckboxVariant || t.isChipVariant) && "100%"
        },
        padding: t.noBorder ? "4px 0px 4px !important" : t.isInline ? "0px !important" : t.isCheckboxVariant || t.isChipVariant ? "0 35px 0 0 !important" : t.isInlineBorder ? "4px 12px 2px !important" : "9px 12px 8px !important",
        fontSize: "16px"
      },
      "& .Mui-disabled": {
        color: "rgba(0, 0, 0, 0.26) !important",
        fontSize: t.isInlineBorder ? "14px" : "16px"
      },
      "& .Mui-disabled:disabled": {
        color: "rgba(0, 0, 0, 0.26) !important",
        cursor: "not-allowed"
      }
    }
  }),
  noBorder: {
    '& fieldset[class*="MuiOutlinedInput-notchedOutline"]': {
      border: "none"
    },
    "& .Mui-disabled": {
      color: `${e.palette.primary.main}`,
      // Keep the text color
      "-webkit-text-fill-color": `${e.palette.primary.main}`,
      // For some browsers
      opacity: 1
      // Prevent fading
    },
    "& input": {
      color: `${e.palette.primary.main}`,
      fontWeight: "500"
    }
  },
  leftBorderRoundedNone: {
    '& [class*="MuiOutlinedInput-root"]': {
      borderTopLeftRadius: "0px !important",
      borderBottomLeftRadius: "0px !important"
    }
  },
  isInline: {
    "& input": {
      color: `${e.palette.text.primary}`,
      fontWeight: "400",
      "&::placeholder": {
        color: `${e.palette.text.secondary}`,
        opacity: 1
      }
    }
  },
  popper: (t) => ({
    zIndex: t.zIndexValue
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  searchable: (t) => ({
    paddingLeft: t.isCheckboxVariant || t.isChipVariant ? "4px !important" : "15px !important",
    width: "auto"
  }),
  paper: {
    backgroundColor: `${e.palette.common.white}`,
    padding: "0px 4px 4px 4px",
    boxShadow: "0px 1px 5px rgba(1, 16, 34, 0.1)",
    borderRadius: "4px",
    border: "1px solid #D2D1D1",
    "& .MuiAutocomplete-option.Mui-focused": {
      backgroundColor: `${e.palette.backgrounds.primary}`
    },
    '& .MuiAutocomplete-option[aria-selected="true"]': {
      backgroundColor: `${e.palette.backgrounds.dark}`,
      color: `${e.palette.primary.main}`
    },
    '& li[class^="MuiAutocomplete-option"]': {
      fontSize: "14px",
      fontFamily: "Roboto",
      lineHeight: "20px",
      padding: "8px 12px",
      marginBottom: "2px",
      backgroundColor: `${e.palette.common.white}`
    },
    '& div[class*="MuiAutocomplete-groupLabel"]': {
      fontSize: "12px !important"
    },
    '& span[class*="MuiCheckbox-root"]': () => ({
      backgroundColor: `${e.palette.common.white}`
    }),
    '& li[data-focus="true"]': {
      backgroundColor: `${e.palette.backgrounds.primary}`,
      "& *": {
        color: `${e.palette.primary.main}`
      },
      "& svg": {
        backgroundColor: "transparent"
      },
      '& span[class*="MuiCheckbox-root"]': {
        backgroundColor: (t) => t.isMultiSelectVariant ? `${e.palette.backgrounds.primary}` : `${e.palette.backgrounds.light}`,
        "&.Mui-checked": {
          backgroundColor: (t) => t.isMultiSelectVariant ? `${e.palette.backgrounds.primary}` : `${e.palette.backgrounds.primary}`
        }
      }
    },
    '& li[aria-selected="true"]': {
      fontWeight: 500,
      color: `${e.palette.primary.main}`,
      "& *": {
        color: `${e.palette.primary.main}`
      }
    }
  },
  chip: {
    borderRadius: "60px",
    border: `1px solid ${e.palette.divider}`,
    background: "#EFF1FF",
    maxWidth: "180px",
    height: "34px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginRight: (t) => t.isMultiSelectVariant ? "0px" : "8px",
    marginBottom: (t) => t.isMultiSelectVariant ? "0px" : "12px",
    marginTop: (t) => t.isMultiSelectVariant ? "4px" : "0px",
    '& span[class^="MuiChip-label"]': {
      fontSize: "14px !important",
      lineHeight: "22px",
      maxWidth: (t) => t.isMultiSelectVariant ? "106px" : "126px",
      padding: (t) => t.isMultiSelectVariant && "0px 8px"
    },
    '& svg[class^="MuiChip-deleteIcon-"]': {
      marginRight: (t) => t.isMultiSelectVariant ? "8px" : "12px"
    },
    "&:focus": {
      background: `${e.palette.common.white}`
    },
    borderColor: "#3543BF"
  },
  small: {
    width: "182px"
  },
  endAdornment: {
    top: "auto"
  },
  checkbox: {
    marginRight: "12.5px",
    backgroundColor: `${e.palette.backgrounds.light}`,
    color: `${e.palette.primary.main}`,
    padding: (t) => t.isMultiSelectVariant && "0px"
  },
  buttonVariant: {
    color: `${e.palette.backgrounds.white} !important`,
    "& .MuiInputBase-root": {
      width: "100% !important",
      background: "#3543BF !important",
      "& .MuiInputBase-input": {
        color: `${e.palette.backgrounds.white} !important`,
        "-webkit-text-fill-color": `${e.palette.backgrounds.white} !important`,
        fontWeight: "600 !important",
        fontSize: "16px !important",
        borderRight: `1px solid ${e.palette.backgrounds.white}`,
        marginRight: "8px"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none"
      }
    }
  }
})), Us = qs, yn = (e, t, n) => {
  const a = kn();
  return e.length ? a(t, {
    inputValue: e,
    getOptionLabel: n
  }) : t;
}, Gs = (e, t, n) => {
  const a = e.map((o) => o[n]), r = Array.isArray(t) && (t == null ? void 0 : t.map((o) => o[n]));
  return a.every((o) => r.indexOf(o) !== -1) && e.length && Array.isArray(t) && t.length;
}, Xs = Te(() => ({
  text: {
    color: "inherit"
  }
})), Qs = ({
  incomingProps: e,
  optionLabel: t,
  optionHierarchicalSubLabel: n
}) => {
  const a = Xs();
  return /* @__PURE__ */ l("div", { ...e, children: /* @__PURE__ */ S(Xe, { container: !0, item: !0, direction: "column", className: a.text, children: [
    /* @__PURE__ */ l(ae, { variant: "body2", fb: !0, className: a.text, children: t }),
    /* @__PURE__ */ l(ae, { variant: "subtitle1", className: a.text, children: n })
  ] }) });
}, Js = Qs, Ks = ({
  optionLabel: e,
  incomingProps: t
}) => /* @__PURE__ */ S("div", { ...t, children: [
  /* @__PURE__ */ l(J.NewSearch, { style: { marginRight: "10px" } }),
  e
] }), Zs = Ks, el = ({
  option: e,
  incomingProps: t,
  selected: n
}) => /* @__PURE__ */ S("div", { ...t, children: [
  /* @__PURE__ */ l(
    Ot,
    {
      className: "h-[14px] w-[14px] p-0 m-0 mr-2 [&>span>svg]:h-[18px]",
      checked: n
    }
  ),
  e
] }), tl = el;
function nl({
  options: e,
  isHierarchicalVariant: t,
  isIconVariant: n,
  isCheckboxVariant: a,
  isMultiSelectVariant: r,
  isCustom: o,
  optionLabel: i,
  hierarchicalLabelField: s,
  renderOption: d,
  labelField: c
}) {
  return Ie(
    (u, f, h) => t ? /* @__PURE__ */ l(
      Js,
      {
        incomingProps: u,
        optionLabel: i(f),
        optionHierarchicalSubLabel: f[s]
      }
    ) : n ? /* @__PURE__ */ l(
      Zs,
      {
        optionLabel: i(f),
        incomingProps: u
      }
    ) : a || r ? /* @__PURE__ */ l(
      tl,
      {
        option: i(f),
        incomingProps: u,
        selected: h.selected
      }
    ) : o ? d(u, f, {
      selected: h.selected,
      inputValue: h.inputValue,
      labelField: c
    }) : /* @__PURE__ */ l("div", { ...u, children: i(f) }),
    [e]
  );
}
const al = (e, t, n, a, r, o, i, s) => (d, c) => {
  if (d) {
    const u = [
      ...e(n, a, r),
      ...i
    ], f = [
      ...new Map(
        u.map((h) => [
          h[o],
          h
        ])
      ).values()
    ];
    s([...f]), c([...f]);
  } else
    t();
}, rl = al, ol = (e) => Ie(
  ({ children: t }) => /* @__PURE__ */ l(La, { className: e, children: t }),
  [e]
), il = ol, sl = (e, t, n, a, r) => () => {
  let o = [];
  e.length && (o = t.filter((i) => !a.find((s) => i[r] === s[r]))), n([...o]);
}, ll = sl, cl = ({
  popupAnchor: e,
  autoCompleteRef: t,
  popperWidth: n,
  increaseZIndex: a,
  ...r
}) => {
  const o = Dt(e) ? t == null ? void 0 : t.current : e.current;
  return /* @__PURE__ */ l(
    Ya,
    {
      ...r,
      style: {
        width: n || (o == null ? void 0 : o.clientWidth),
        ...a ? { zIndex: 9999999999 } : { zIndex: 1300 }
      },
      anchorEl: o
    }
  );
}, dl = cl, ul = ({
  valueField: e,
  labelField: t,
  allSelected: n,
  classesCheckbox: a,
  SELECT_ALL_OPTION: r
}) => (o, i, s) => {
  let d = {};
  return i[e] === r.label && (d = { checked: n }), /* @__PURE__ */ l("div", { ...o, children: /* @__PURE__ */ S("li", { children: [
    /* @__PURE__ */ l(
      Ot,
      {
        className: a,
        checked: s.selected,
        ...d
      }
    ),
    i[t]
  ] }) });
}, fl = ul, hl = ({
  tags: e,
  isMultiSelectVariant: t,
  disabled: n,
  chipClasses: a,
  optionLabel: r,
  valueField: o,
  setTags: i,
  onChange: s,
  setTagOptions: d,
  options: c,
  displayWarning: u,
  maxTagsText: f,
  maxTags: h,
  value: m,
  name: p
}) => !e || e && e.length === 0 ? null : /* @__PURE__ */ S(
  Xe,
  {
    container: !0,
    direction: "row",
    className: `${t && "gap-1"}`,
    children: [
      e == null ? void 0 : e.map((b, v) => /* @__PURE__ */ l(Xe, { children: /* @__PURE__ */ l(
        Cn,
        {
          disabled: n,
          clickable: !1,
          className: a,
          label: r(b),
          onDelete: () => {
            const x = e.filter((y) => o ? y[o] !== b[o] : r(y) !== r(b));
            i(x), s(x, p, ""), d(
              c.filter(
                (y) => x.every(
                  (C) => JSON.stringify(C) !== JSON.stringify(y)
                )
              )
            );
          },
          deleteIcon: /* @__PURE__ */ l(
            J.Close,
            {
              style: { width: "16px", height: "16px" },
              "data-test-id": `${r(b)}_chip_cross`
            }
          )
        }
      ) }, `chip_${v}`)),
      u && f && h !== 1 / 0 && (m == null ? void 0 : m.length) >= h && /* @__PURE__ */ l(Xe, { xs: 12, children: /* @__PURE__ */ l($a, { my: 1, children: /* @__PURE__ */ l(ae, { themeColor: "error.main", children: f }) }) })
    ]
  }
), xn = hl, ml = ({
  incomingChipValue: e,
  option: t,
  disabled: n,
  optionLabel: a,
  onChange: r,
  name: o,
  isMultiple: i
}) => /* @__PURE__ */ S("div", { className: [
  "flex items-center gap-1 rounded-full border border-solid border-[1px] px-[6px]",
  n ? "bg-color-light border-color-divider pointer-events-none" : "border-primary-light bg-color-primary",
  i ? "ml-2" : ""
].join(" "), children: [
  /* @__PURE__ */ l(
    ae,
    {
      variant: "body1",
      className: "max-w-[100px] text-ellipsis overflow-hidden whitespace-nowrap",
      children: a(t)
    }
  ),
  /* @__PURE__ */ l(
    J.Cross,
    {
      className: "cursor-pointer",
      height: 10,
      width: 10,
      onClick: () => {
        const d = e.filter(
          (c) => a(c) !== a(t)
        );
        r(d, o, "");
      },
      "aria-disabled": n,
      stroke: n ? "#D2D1D1" : "#3543BF"
    }
  )
] }), pl = ml;
function gl(e, t) {
  const {
    value: n,
    options: a,
    onChange: r,
    onBlur: o,
    placeholder: i = "Select",
    limitTags: s,
    labelField: d = "label",
    valueField: c = "",
    searchable: u = !1,
    disableClear: f = !1,
    disabled: h = !1,
    noOptionsText: m = "No options",
    optionVariant: p = "text",
    hierarchicalLabelField: b,
    isMultiple: v = !1,
    groupByField: x = null,
    size: y = "medium",
    name: C = "",
    autoFocus: N = !1,
    increaseZIndex: M = !0,
    displayRightEl: I = null,
    maxTags: T = 1 / 0,
    maxTagsText: R = `You can select upto ${T} items`,
    extraDeps: A = [],
    className: B = "",
    popupAnchor: L,
    noBorder: H = !1,
    leftBorderRoundedNone: fe = !1,
    style: he,
    renderOption: q,
    popperWidth: me = null,
    menuContainer: k,
    leftIcon: w = null,
    showSearchIcon: $ = !0,
    error: ie = !1,
    isInline: se = !1,
    isInlineBorder: je = !1,
    rigthIconColor: z = "text-text-primary",
    defaultValues: Ee = [],
    onClick: ve = () => {
    },
    isButtonVariant: sa = !1,
    rightIcon: la = null,
    filterOptions: Vt = null,
    ...ca
  } = e, [Ce, ke] = E([]), [st, Pe] = E(a), [jt, lt] = E(!1), [qe, da] = E(""), qt = xe(null), ua = p === "hierarchical", fa = p === "withIcon", ct = p === "checkbox", Z = p === "multiSelect", ha = p === "custom", ma = p === "tags", Ut = p === "chips", pa = M ? "100000002 !important" : "auto", ga = kt(ca), va = v && p === "tags", Ue = { label: "Select All", value: "Select All" }, Gt = kn(), Xt = Gs(st, Ce, c), be = Ie(
    (O) => typeof O == "string" ? O : O == null ? void 0 : O[d],
    [d]
  ), V = Us({
    isInlineBorder: je,
    zIndexValue: pa,
    noBorder: H,
    isInline: se,
    isCheckboxVariant: ct,
    disabled: h,
    isMultiSelectVariant: Z,
    isChipVariant: Ut
  }), ba = nl({
    options: a,
    isHierarchicalVariant: ua,
    isIconVariant: fa,
    isCheckboxVariant: ct,
    isMultiSelectVariant: Z,
    isCustom: ha,
    optionLabel: be,
    hierarchicalLabelField: b,
    renderOption: q,
    labelField: d
  }), ya = fl({
    valueField: c,
    labelField: d,
    allSelected: Xt,
    classesCheckbox: V.checkbox,
    SELECT_ALL_OPTION: Ue
  }), xa = il(V.paper), wa = ll(
    qe,
    Ce,
    ke,
    st,
    c
  ), Qt = rl(
    yn,
    wa,
    qe,
    a,
    be,
    c,
    Ce,
    ke
  ), Ca = (O) => {
    typeof Qt == "function" && Qt(!Xt, O);
  }, Jt = (O) => ke(O), Kt = (O, P, te = "") => {
    if ((te === "selectOption" || te === "removeOption") && Z) {
      O.find((dt) => dt[c] === Ue.label) ? Ca(r) : (r(
        O.filter(
          (dt) => dt[c] !== Ue.label
        ),
        P,
        te
      ), typeof Jt == "function" && Jt(O)), lt(!1);
      return;
    }
    p === "tags" && (n == null ? void 0 : n.length) >= T ? lt(!0) : (lt(!1), r(O, P, te));
  }, ka = (O, P) => {
    u || (P.inputValue = "");
    const te = Gt(a, P);
    return Z ? [Ue, ...te] : te;
  }, Da = ({ target: { value: O } }) => {
    if (da(O), Z) {
      const P = O.length ? Gt(a, {
        inputValue: O,
        getOptionLabel: be
      }) : a;
      Pe([...P]);
    }
  }, Ma = p === "tags" && (n == null ? void 0 : n.length) < T || p === "checkbox" || p === "multiSelect" || p === "chips" && v, Zt = {};
  return Z && (Zt.inputValue = qe), Q(() => {
    va && ke(n);
  }, [n]), Q(() => {
    Z && ke(Ee);
  }, [Ee]), Q(() => {
    v && (p === "tags" || p === "chips") && Pe(
      a.filter(
        (O) => n == null ? void 0 : n.every(
          (P) => JSON.stringify(P) !== JSON.stringify(O)
        )
      )
    );
  }, [...A, a]), /* @__PURE__ */ S(ee, { children: [
    ma ? /* @__PURE__ */ l(
      xn,
      {
        tags: Ce,
        isMultiSelectVariant: Z,
        disabled: h,
        chipClasses: V.chip,
        optionLabel: be,
        valueField: c,
        setTags: ke,
        onChange: r,
        setTagOptions: Pe,
        options: a,
        displayWarning: jt,
        maxTagsText: R,
        maxTags: T,
        value: n,
        name: C
      }
    ) : null,
    /* @__PURE__ */ l(
      Pa,
      {
        onClick: ve,
        classes: {
          root: V.autocompleteRoot,
          popper: V.popper,
          endAdornment: V.endAdornment
        },
        openOnFocus: !0,
        ref: qt,
        value: Z ? Ce : (n == null ? void 0 : n.value) === null || _a(n) ? v ? [] : "" : n,
        style: he,
        limitTags: s,
        options: p === "tags" || p === "multiSelect" ? st : a,
        onChange: (O, P, te) => Kt(P, C, te),
        onBlur: (O) => {
          Pe(Z ? yn(qe, a, be) : a.filter(
            (P) => Ce.every(
              (te) => JSON.stringify(te) !== JSON.stringify(P)
            )
          )), typeof o == "function" && o(O);
        },
        getOptionLabel: be,
        popupIcon: la || /* @__PURE__ */ l(
          J.ChevronDownUnfilled,
          {
            className: X(
              h ? "" : se || ct || je ? "text-text-primary" : "text-primary-default",
              h ? "" : z
            )
          }
        ),
        clearIcon: /* @__PURE__ */ l(J.CloseSmall, {}),
        disableClearable: v ? !0 : f,
        PaperComponent: xa,
        ListboxComponent: k,
        PopperComponent: (O) => /* @__PURE__ */ l(
          dl,
          {
            ...O,
            popupAnchor: L,
            autoCompleteRef: qt,
            popperWidth: me
          }
        ),
        disabled: h,
        selectOnFocus: !1,
        noOptionsText: m,
        renderInput: (O) => {
          const P = {
            ...O.InputProps,
            readOnly: !u,
            ...w && { startAdornment: w }
          };
          return $ && (u && !v || p === "tags" || p === "multiSelect") && (P.startAdornment = /* @__PURE__ */ l(J.NewSearch, { className: V.searchable })), Dt(I) || (P.endAdornment = /* @__PURE__ */ S(ee, { children: [
            I(n),
            P.endAdornment
          ] })), /* @__PURE__ */ l(
            Fa,
            {
              ...O,
              autoFocus: N,
              inputRef: t,
              InputProps: P,
              placeholder: Ut && v ? "" : i,
              variant: "outlined",
              error: ie,
              disabled: !u || h,
              style: { caretColor: u ? "unset" : "transparent" },
              onChange: Da,
              className: X(
                V.root,
                V.notFaded,
                y === "small" && V.small,
                B,
                (H || se) && V.noBorder,
                fe && V.leftBorderRoundedNone,
                se && V.isInline,
                sa && V.buttonVariant
              )
            }
          );
        },
        groupBy: x,
        renderOption: p !== "multiSelect" ? ba : ya,
        multiple: v,
        disableCloseOnSelect: Ma,
        isOptionEqualToValue: (O, P) => typeof P == "string" ? O === P : c ? O[c] === (P == null ? void 0 : P[c]) : O[d] === (P == null ? void 0 : P[d]),
        renderTags: (O) => O.map((P) => /* @__PURE__ */ l(
          pl,
          {
            incomingChipValue: O,
            option: P,
            disabled: h,
            optionLabel: be,
            onChange: Kt,
            name: C,
            isMultiple: v
          }
        )),
        filterOptions: typeof Vt == "function" ? Vt : ka,
        ...Zt,
        ...ga
      }
    ),
    Z ? /* @__PURE__ */ l(
      xn,
      {
        tags: Ce,
        isMultiSelectVariant: Z,
        disabled: h,
        chipClasses: V.chip,
        optionLabel: be,
        valueField: c,
        setTags: ke,
        onChange: r,
        setTagOptions: Pe,
        options: a,
        displayWarning: jt,
        maxTagsText: R,
        maxTags: T,
        value: n,
        name: C
      }
    ) : null
  ] });
}
const vl = et(gl);
export {
  dl as A,
  Je as B,
  Ot as C,
  Vs as D,
  Tl as E,
  Wl as F,
  Js as H,
  Ct as I,
  js as P,
  br as R,
  _n as S,
  vl as _,
  Pl as a,
  _l as b,
  Er as c,
  K as d,
  Fl as e,
  Rl as f,
  Ae as g,
  $n as h,
  Se as i,
  zn as j,
  Yn as k,
  j as l,
  Il as m,
  Ke as n,
  Ln as o,
  No as p,
  Io as q,
  Fo as r,
  ue as s,
  _ as t,
  Ol as u,
  Ws as v,
  Ro as w,
  Sr as x,
  Hn as y,
  il as z
};
//# sourceMappingURL=hooks.entry-894e618a.js.map
